/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }

function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));) { ; } return t; }

function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }

function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }

function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }

function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }

function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }

function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n2 = 0, F = function F() {}; return { s: F, n: function n() { return _n2 >= r.length ? { done: !0 } : { done: !1, value: r[_n2++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

var aa = {},
    ba = {},
    da = {},
    ea = {},
    fa = {},
    ha = {},
    ka = {},
    ma = {},
    na = {},
    pa = {},
    qa = {},
    ra = {},
    sa = {},
    ta = {},
    ua = {},
    va = {},
    xa = {},
    ya = {},
    za = {},
    Aa = {},
    Ba = {},
    Ca = {},
    Fa = {},
    Ga = {},
    Ha = {},
    Ia = {},
    Ja = {},
    Ka = {},
    La = {},
    Ma = {},
    Na = {},
    Oa = {},
    Pa = {},
    Qa = {},
    Ra = {},
    Sa = {};

function r(a) {
  var b = new URLSearchParams();
  b.append("code", a);

  for (var c = 1; c < arguments.length; c++) {
    b.append("v", arguments[c]);
  }

  throw Error("Minified Lexical error #".concat(a, "; visit https://lexical.dev/docs/error?").concat(b, " for the full message or ") + "use the non-minified dev environment for full errors and additional helpful warnings.");
}

var Ta = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement,
    Ua = Ta && "documentMode" in document ? document.documentMode : null,
    t = Ta && /Mac|iPod|iPhone|iPad/.test(navigator.platform),
    Wa = Ta && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent),
    Xa = Ta && "InputEvent" in window && !Ua ? "getTargetRanges" in new window.InputEvent("input") : !1,
    Ya = Ta && /Version\/[\d.]+.*Safari/.test(navigator.userAgent),
    Za = Ta && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
    $a = Ta && /^(?=.*Chrome).*/i.test(navigator.userAgent),
    ab = Ta && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !$a,
    bb = Ya || Za || ab ? "\xA0" : "\u200B",
    cb = Wa ? "\xA0" : bb,
    db = /^[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]*[\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]/,
    eb = /^[^\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]*[A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]/,
    fb = {
  bold: 1,
  code: 16,
  highlight: 128,
  italic: 2,
  strikethrough: 4,
  subscript: 32,
  superscript: 64,
  underline: 8
},
    gb = {
  directionless: 1,
  unmergeable: 2
},
    hb = {
  center: 2,
  end: 6,
  justify: 4,
  left: 1,
  right: 3,
  start: 5
},
    ib = {
  2: "center",
  6: "end",
  4: "justify",
  1: "left",
  3: "right",
  5: "start"
},
    jb = {
  normal: 0,
  segmented: 2,
  token: 1
},
    kb = {
  0: "normal",
  2: "segmented",
  1: "token"
},
    ob = !1,
    pb = 0;

function qb(a) {
  pb = a.timeStamp;
}

function rb(a, b, c) {
  return b.__lexicalLineBreak === a || void 0 !== a["__lexicalKey_".concat(c._key)];
}

function sb(a) {
  return a.getEditorState().read(function () {
    var b = v();
    return null !== b ? b.clone() : null;
  });
}

function tb(a, b, c) {
  ob = !0;
  var d = 100 < performance.now() - pb;

  try {
    w(a, function () {
      var e = v() || sb(a);
      var f = new Map(),
          g = a.getRootElement(),
          h = a._editorState,
          k = a._blockCursorElement;
      var m = !1,
          n = "";

      for (var p = 0; p < b.length; p++) {
        var l = b[p],
            q = l.type,
            u = l.target,
            x = ub(u, h);
        if (!(null === x && u !== g || z(x))) if ("characterData" === q) {
          if (l = d && B(x)) a: {
            l = e;
            q = u;
            var y = x;

            if (C(l)) {
              var A = l.anchor.getNode();

              if (A.is(y) && l.format !== A.getFormat()) {
                l = !1;
                break a;
              }
            }

            l = 3 === q.nodeType && y.isAttached();
          }
          l && (y = vb(a._window), q = l = null, null !== y && y.anchorNode === u && (l = y.anchorOffset, q = y.focusOffset), u = u.nodeValue, null !== u && wb(x, u, l, q, !1));
        } else if ("childList" === q) {
          m = !0;
          q = l.addedNodes;

          for (y = 0; y < q.length; y++) {
            A = q[y];
            var Z = xb(A),
                ca = A.parentNode;
            null == ca || A === k || null !== Z || "BR" === A.nodeName && rb(A, ca, a) || (Wa && (Z = A.innerText || A.nodeValue) && (n += Z), ca.removeChild(A));
          }

          l = l.removedNodes;
          q = l.length;

          if (0 < q) {
            y = 0;

            for (A = 0; A < q; A++) {
              if (ca = l[A], "BR" === ca.nodeName && rb(ca, u, a) || k === ca) u.appendChild(ca), y++;
            }

            q !== y && (u === g && (x = h._nodeMap.get("root")), f.set(u, x));
          }
        }
      }

      if (0 < f.size) {
        var _iterator = _createForOfIteratorHelper(f),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ref3 = _step.value;

            var _ref2 = _slicedToArray(_ref3, 2);

            var Va = _ref2[0];
            var la = _ref2[1];
            if (D(la)) for (f = la.getChildrenKeys(), g = Va.firstChild, h = 0; h < f.length; h++) {
              k = a.getElementByKey(f[h]), null !== k && (null == g ? (Va.appendChild(k), g = k) : g !== k && Va.replaceChild(k, g), g = g.nextSibling);
            } else B(la) && la.markDirty();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      f = c.takeRecords();

      if (0 < f.length) {
        for (g = 0; g < f.length; g++) {
          for (k = f[g], h = k.addedNodes, k = k.target, p = 0; p < h.length; p++) {
            x = h[p], u = x.parentNode, null == u || "BR" !== x.nodeName || rb(x, k, a) || u.removeChild(x);
          }
        }

        c.takeRecords();
      }

      null !== e && (m && (e.dirty = !0, yb(e)), Wa && zb(a) && e.insertRawText(n));
    });
  } finally {
    ob = !1;
  }
}

function Ab(a) {
  var b = a._observer;

  if (null !== b) {
    var c = b.takeRecords();
    tb(a, c, b);
  }
}

function Bb(a) {
  0 === pb && Cb(a).addEventListener("textInput", qb, !0);
  a._observer = new MutationObserver(function (b, c) {
    tb(a, b, c);
  });
}

function Db(a, b) {
  var c = a.__mode,
      d = a.__format;
  a = a.__style;
  var e = b.__mode,
      f = b.__format;
  b = b.__style;
  return (null === c || c === e) && (null === d || d === f) && (null === a || a === b);
}

function Eb(a, b) {
  var c = a.mergeWithSibling(b),
      d = F()._normalizedNodes;

  d.add(a.__key);
  d.add(b.__key);
  return c;
}

function Fb(a) {
  if ("" === a.__text && a.isSimpleText() && !a.isUnmergeable()) a.remove();else {
    for (var b; null !== (b = a.getPreviousSibling()) && B(b) && b.isSimpleText() && !b.isUnmergeable();) {
      if ("" === b.__text) b.remove();else {
        Db(b, a) && (a = Eb(b, a));
        break;
      }
    }

    for (var c; null !== (c = a.getNextSibling()) && B(c) && c.isSimpleText() && !c.isUnmergeable();) {
      if ("" === c.__text) c.remove();else {
        Db(a, c) && Eb(a, c);
        break;
      }
    }
  }
}

function Gb(a) {
  Hb(a.anchor);
  Hb(a.focus);
  return a;
}

function Hb(a) {
  for (; "element" === a.type;) {
    var b = a.getNode(),
        c = a.offset;
    c === b.getChildrenSize() ? (b = b.getChildAtIndex(c - 1), c = !0) : (b = b.getChildAtIndex(c), c = !1);

    if (B(b)) {
      a.set(b.__key, c ? b.getTextContentSize() : 0, "text");
      break;
    } else if (!D(b)) break;

    a.set(b.__key, c ? b.getChildrenSize() : 0, "element");
  }
}

var Ib = 1,
    Jb = "function" === typeof queueMicrotask ? queueMicrotask : function (a) {
  Promise.resolve().then(a);
};

function Kb(a) {
  var b = document.activeElement;
  if (null === b) return !1;
  var c = b.nodeName;
  return z(ub(a)) && ("INPUT" === c || "TEXTAREA" === c || "true" === b.contentEditable && null == b.__lexicalEditor);
}

function Lb(a, b, c) {
  var d = a.getRootElement();

  try {
    return null !== d && d.contains(b) && d.contains(c) && null !== b && !Kb(b) && Mb(b) === a;
  } catch (e) {
    return !1;
  }
}

function Mb(a) {
  for (; null != a;) {
    var b = a.__lexicalEditor;
    if (null != b) return b;
    a = Nb(a);
  }

  return null;
}

function Ob(a) {
  return a.isToken() || a.isSegmented();
}

function Vb(a) {
  for (; null != a;) {
    if (3 === a.nodeType) return a;
    a = a.firstChild;
  }

  return null;
}

function Wb(a, b, c) {
  b = fb[b];
  return a & b && (null === c || 0 === (c & b)) ? a ^ b : null === c || c & b ? a | b : a;
}

function Xb(a) {
  return B(a) || Yb(a) || z(a);
}

function Zb(a, b) {
  if (null != b) a.__key = b;else {
    G();
    99 < $b && r(14);
    b = F();
    var c = ac(),
        d = "" + Ib++;

    c._nodeMap.set(d, a);

    D(a) ? b._dirtyElements.set(d, !0) : b._dirtyLeaves.add(d);

    b._cloneNotNeeded.add(d);

    b._dirtyType = 1;
    a.__key = d;
  }
}

function bc(a) {
  var b = a.getParent();

  if (null !== b) {
    var e = a.getWritable();
    b = b.getWritable();
    var c = a.getPreviousSibling();
    a = a.getNextSibling();
    if (null === c) {
      if (null !== a) {
        var d = a.getWritable();
        b.__first = a.__key;
        d.__prev = null;
      } else b.__first = null;
    } else {
      d = c.getWritable();

      if (null !== a) {
        var f = a.getWritable();
        f.__prev = d.__key;
        d.__next = f.__key;
      } else d.__next = null;

      e.__prev = null;
    }
    null === a ? null !== c ? (a = c.getWritable(), b.__last = c.__key, a.__next = null) : b.__last = null : (a = a.getWritable(), null !== c ? (c = c.getWritable(), c.__next = a.__key, a.__prev = c.__key) : a.__prev = null, e.__next = null);
    b.__size--;
    e.__parent = null;
  }
}

function cc(a) {
  99 < $b && r(14);
  var b = a.getLatest(),
      c = b.__parent,
      d = ac();
  var e = F(),
      f = d._nodeMap;
  d = e._dirtyElements;
  if (null !== c) a: for (; null !== c;) {
    if (d.has(c)) break a;
    var g = f.get(c);
    if (void 0 === g) break;
    d.set(c, !1);
    c = g.__parent;
  }
  b = b.__key;
  e._dirtyType = 1;
  D(a) ? d.set(b, !0) : e._dirtyLeaves.add(b);
}

function H(a) {
  G();
  var b = F();
  var c = b._compositionKey;
  a !== c && (b._compositionKey = a, null !== c && (b = I(c), null !== b && b.getWritable()), null !== a && (a = I(a), null !== a && a.getWritable()));
}

function dc() {
  return ec() ? null : F()._compositionKey;
}

function I(a, b) {
  a = (b || ac())._nodeMap.get(a);
  return void 0 === a ? null : a;
}

function xb(a, b) {
  var c = F();
  a = a["__lexicalKey_".concat(c._key)];
  return void 0 !== a ? I(a, b) : null;
}

function ub(a, b) {
  for (; null != a;) {
    var c = xb(a, b);
    if (null !== c) return c;
    a = Nb(a);
  }

  return null;
}

function fc(a) {
  var b = Object.assign({}, a._decorators);
  return a._pendingDecorators = b;
}

function gc(a) {
  return a.read(function () {
    return hc().getTextContent();
  });
}

function ic(a, b) {
  w(a, function () {
    var c = ac();
    if (!c.isEmpty()) if ("root" === b) hc().markDirty();else {
      c = c._nodeMap;

      var _iterator2 = _createForOfIteratorHelper(c),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ref6 = _step2.value;

          var _ref5 = _slicedToArray(_ref6, 2);

          var d = _ref5[1];
          d.markDirty();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, null === a._pendingEditorState ? {
    tag: "history-merge"
  } : void 0);
}

function hc() {
  return ac()._nodeMap.get("root");
}

function yb(a) {
  G();
  var b = ac();
  null !== a && (a.dirty = !0, a._cachedNodes = null);
  b._selection = a;
}

function jc(a) {
  var b = F(),
      c;

  a: {
    for (c = a; null != c;) {
      var d = c["__lexicalKey_".concat(b._key)];

      if (void 0 !== d) {
        c = d;
        break a;
      }

      c = Nb(c);
    }

    c = null;
  }

  return null === c ? (b = b.getRootElement(), a === b ? I("root") : null) : I(c);
}

function kc(a) {
  return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(a);
}

function lc(a) {
  var b = [];

  for (; null !== a;) {
    b.push(a), a = a._parentEditor;
  }

  return b;
}

function mc() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}

function nc(a, b, c) {
  b = vb(b._window);

  if (null !== b) {
    var d = b.anchorNode,
        _b = b,
        e = _b.anchorOffset,
        f = _b.focusOffset;

    if (null !== d && (b = 3 === d.nodeType ? d.nodeValue : null, d = ub(d), null !== b && B(d))) {
      if (b === bb && c) {
        var g = c.length;
        b = c;
        f = e = g;
      }

      null !== b && wb(d, b, e, f, a);
    }
  }
}

function wb(a, b, c, d, e) {
  var f = a;

  if (f.isAttached() && (e || !f.isDirty())) {
    var m = f.isComposing(),
        n = b;
    (m || e) && b[b.length - 1] === bb && (n = b.slice(0, -1));
    b = f.getTextContent();
    if (e || n !== b) if ("" === n) {
      if (H(null), Ya || Za || ab) f.remove();else {
        var p = F();
        setTimeout(function () {
          p.update(function () {
            f.isAttached() && f.remove();
          });
        }, 20);
      }
    } else {
      e = f.getParent();
      b = oc();
      var g = f.getTextContentSize(),
          h = dc(),
          k = f.getKey();
      f.isToken() || null !== h && k === h && !m || C(b) && (null !== e && !e.canInsertTextBefore() && 0 === b.anchor.offset || b.anchor.key === a.__key && 0 === b.anchor.offset && !f.canInsertTextBefore() || b.focus.key === a.__key && b.focus.offset === g && !f.canInsertTextAfter()) ? f.markDirty() : (a = v(), C(a) && null !== c && null !== d && (a.setTextNodeRange(f, c, f, d), f.isSegmented() && (c = f.getTextContent(), c = J(c), f.replace(c), f = c)), f.setTextContent(n));
    }
  }
}

function pc(a, b) {
  if (b.isSegmented()) return !0;
  if (!a.isCollapsed()) return !1;
  a = a.anchor.offset;
  var c = b.getParentOrThrow(),
      d = b.isToken();
  return 0 === a ? ((a = !b.canInsertTextBefore() || !c.canInsertTextBefore() || d) || (b = b.getPreviousSibling(), a = (B(b) || D(b) && b.isInline()) && !b.canInsertTextAfter()), a) : a === b.getTextContentSize() ? !b.canInsertTextAfter() || !c.canInsertTextAfter() || d : !1;
}

function qc(a, b) {
  void 0 === a.__lexicalClassNameCache && (a.__lexicalClassNameCache = {});
  var c = a.__lexicalClassNameCache,
      d = c[b];
  if (void 0 !== d) return d;
  a = a[b];
  return "string" === typeof a ? (a = a.split(" "), c[b] = a) : a;
}

function rc(a, b, c, d, e) {
  0 !== c.size && (c = d.__type, d = d.__key, b = b.get(c), void 0 === b && r(33, c), c = b.klass, b = a.get(c), void 0 === b && (b = new Map(), a.set(c, b)), a = b.get(d), c = "destroyed" === a && "created" === e, (void 0 === a || c) && b.set(d, c ? "updated" : e));
}

function sc(a, b, c) {
  var d = a.getParent(),
      e = c;
  null !== d && (b && 0 === c ? (e = a.getIndexWithinParent(), a = d) : b || c !== a.getChildrenSize() || (e = a.getIndexWithinParent() + 1, a = d));
  return a.getChildAtIndex(b ? e - 1 : e);
}

function tc(a, b) {
  var c = a.offset;
  if ("element" === a.type) return a = a.getNode(), sc(a, b, c);
  a = a.getNode();
  return b && 0 === c || !b && c === a.getTextContentSize() ? (c = b ? a.getPreviousSibling() : a.getNextSibling(), null === c ? sc(a.getParentOrThrow(), b, a.getIndexWithinParent() + (b ? 0 : 1)) : c) : null;
}

function zb(a) {
  a = (a = Cb(a).event) && a.inputType;
  return "insertFromPaste" === a || "insertFromPasteAsQuotation" === a;
}

function uc(a) {
  return !K(a) && !a.isLastChild() && !a.isInline();
}

function vc(a, b) {
  a = a._keyToDOMMap.get(b);
  void 0 === a && r(75, b);
  return a;
}

function Nb(a) {
  a = a.assignedSlot || a.parentElement;
  return null !== a && 11 === a.nodeType ? a.host : a;
}

function wc(a, b) {
  for (a = a.getParent(); null !== a;) {
    if (a.is(b)) return !0;
    a = a.getParent();
  }

  return !1;
}

function Cb(a) {
  a = a._window;
  null === a && r(78);
  return a;
}

function xc(a) {
  for (a = a.getParentOrThrow(); null !== a && !yc(a);) {
    a = a.getParentOrThrow();
  }

  return a;
}

function yc(a) {
  return K(a) || D(a) && a.isShadowRoot();
}

function zc(a) {
  a = a.constructor.clone(a);
  Zb(a, null);
  return a;
}

function Ac(a) {
  var b = F();
  var c = a.constructor.getType();
  b = b._nodes.get(c);
  void 0 === b && r(97);
  b = b.replace;
  return null !== b ? (b = b(a), b instanceof a.constructor || r(98), b) : a;
}

function Bc(a, b) {
  a = a.getParent();
  !K(a) || D(b) || z(b) || r(99);
}

function Cc(a) {
  return (z(a) || D(a) && !a.canBeEmpty()) && !a.isInline();
}

function Dc(a, b, c) {
  c.style.removeProperty("caret-color");
  b._blockCursorElement = null;
  b = a.parentElement;
  null !== b && b.removeChild(a);
}

function vb(a) {
  return Ta ? (a || window).getSelection() : null;
}

function Ec(a, b) {
  var c = a.getChildAtIndex(b);
  null == c && (c = a);
  yc(a) && r(102);

  var d = function d(g) {
    var h = g.getParentOrThrow(),
        k = yc(h),
        m = g !== c || k ? zc(g) : g;
    if (k) return g.insertAfter(m), [g, m, m];

    var _d3 = d(h),
        _d4 = _slicedToArray(_d3, 3),
        n = _d4[0],
        p = _d4[1],
        l = _d4[2];

    g = g.getNextSiblings();
    l.append.apply(l, [m].concat(_toConsumableArray(g)));
    return [n, p, m];
  },
      _d = d(c),
      _d2 = _slicedToArray(_d, 2),
      e = _d2[0],
      f = _d2[1];

  return [e, f];
}

function Fc(a, b) {
  for (; a !== hc() && null != a;) {
    if (b(a)) return a;
    a = a.getParent();
  }

  return null;
}

function Gc(a) {
  var b = [],
      c = [a];

  for (; 0 < c.length;) {
    var d = c.pop();
    void 0 === d && r(112);
    D(d) && c.unshift.apply(c, _toConsumableArray(d.getChildren()));
    d !== a && b.push(d);
  }

  return b;
}

function Hc(a) {
  return 1 === a.nodeType;
}

function Ic(a, b, c, d, e, f) {
  for (a = a.getFirstChild(); null !== a;) {
    var g = a.__key;
    a.__parent === b && (D(a) && Ic(a, g, c, d, e, f), c.has(g) || f.delete(g), e.push(g));
    a = a.getNextSibling();
  }
}

function Jc(a, b, c, d) {
  a = a._nodeMap;
  b = b._nodeMap;
  var e = [];

  var _iterator3 = _createForOfIteratorHelper(d),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ref9 = _step3.value;

      var _ref8 = _slicedToArray(_ref9, 1);

      var _f = _ref8[0];
      var g = b.get(_f);
      void 0 === g || g.isAttached() || (D(g) && Ic(g, _f, a, b, e, d), a.has(_f) || d.delete(_f), e.push(_f));
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  for (var _i = 0, _e = e; _i < _e.length; _i++) {
    var f = _e[_i];
    b.delete(f);
  }

  var _iterator4 = _createForOfIteratorHelper(c),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _f2 = _step4.value;
      d = b.get(_f2), void 0 === d || d.isAttached() || (a.has(_f2) || c.delete(_f2), b.delete(_f2));
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}

var L = "",
    M = "",
    Kc = "",
    Lc,
    N,
    Mc,
    Nc = !1,
    Oc = !1,
    Pc,
    Qc = null,
    Rc,
    Sc,
    Tc,
    Uc,
    Vc,
    ed;

function fd(a, b) {
  var c = Tc.get(a);

  if (null !== b) {
    var d = gd(a);
    d.parentNode === b && b.removeChild(d);
  }

  Uc.has(a) || N._keyToDOMMap.delete(a);
  D(c) && (a = hd(c, Tc), id(a, 0, a.length - 1, null));
  void 0 !== c && rc(ed, Mc, Pc, c, "destroyed");
}

function id(a, b, c, d) {
  for (; b <= c; ++b) {
    var e = a[b];
    void 0 !== e && fd(e, d);
  }
}

function jd(a, b) {
  a.setProperty("text-align", b);
}

function kd(a, b) {
  var c = Lc.theme.indent;

  if ("string" === typeof c) {
    var d = a.classList.contains(c);
    0 < b && !d ? a.classList.add(c) : 1 > b && d && a.classList.remove(c);
  }

  c = getComputedStyle(a).getPropertyValue("--lexical-indent-base-value") || "40px";
  a.style.setProperty("padding-inline-start", 0 === b ? "" : "calc(".concat(b, " * ").concat(c, ")"));
}

function ld(a, b) {
  a = a.style;
  0 === b ? jd(a, "") : 1 === b ? jd(a, "left") : 2 === b ? jd(a, "center") : 3 === b ? jd(a, "right") : 4 === b ? jd(a, "justify") : 5 === b ? jd(a, "start") : 6 === b && jd(a, "end");
}

function md(a, b, c) {
  var d = Uc.get(a);
  void 0 === d && r(60);
  var e = d.createDOM(Lc, N);
  var f = N._keyToDOMMap;
  e["__lexicalKey_" + N._key] = a;
  f.set(a, e);
  B(d) ? e.setAttribute("data-lexical-text", "true") : z(d) && e.setAttribute("data-lexical-decorator", "true");

  if (D(d)) {
    a = d.__indent;
    f = d.__size;
    0 !== a && kd(e, a);

    if (0 !== f) {
      --f;
      a = hd(d, Uc);
      var g = M;
      M = "";
      nd(a, d, 0, f, e, null);
      od(d, e);
      M = g;
    }

    a = d.__format;
    0 !== a && ld(e, a);
    d.isInline() || pd(null, d, e);
    uc(d) && (L += "\n\n", Kc += "\n\n");
  } else f = d.getTextContent(), z(d) ? (g = d.decorate(N, Lc), null !== g && qd(a, g), e.contentEditable = "false") : B(d) && (d.isDirectionless() || (M += f)), L += f, Kc += f;

  null !== b && (null != c ? b.insertBefore(e, c) : (c = b.__lexicalLineBreak, null != c ? b.insertBefore(e, c) : b.appendChild(e)));
  rc(ed, Mc, Pc, d, "created");
  return e;
}

function nd(a, b, c, d, e, f) {
  var g = L;

  for (L = ""; c <= d; ++c) {
    md(a[c], e, f);
  }

  uc(b) && (L += "\n\n");
  e.__lexicalTextContent = L;
  L = g + L;
}

function rd(a, b) {
  a = b.get(a);
  return Yb(a) || z(a) && a.isInline();
}

function pd(a, b, c) {
  a = null !== a && (0 === a.__size || rd(a.__last, Tc));
  b = 0 === b.__size || rd(b.__last, Uc);
  a ? b || (b = c.__lexicalLineBreak, null != b && c.removeChild(b), c.__lexicalLineBreak = null) : b && (b = document.createElement("br"), c.__lexicalLineBreak = b, c.appendChild(b));
}

function od(a, b) {
  var c = b.__lexicalDir;

  if (b.__lexicalDirTextContent !== M || c !== Qc) {
    var f = "" === M;
    if (f) var d = Qc;else d = M, d = db.test(d) ? "rtl" : eb.test(d) ? "ltr" : null;

    if (d !== c) {
      var g = b.classList,
          h = Lc.theme;
      var e = null !== c ? h[c] : void 0;
      var k = null !== d ? h[d] : void 0;
      void 0 !== e && ("string" === typeof e && (e = e.split(" "), e = h[c] = e), g.remove.apply(g, _toConsumableArray(e)));
      null === d || f && "ltr" === d ? b.removeAttribute("dir") : (void 0 !== k && ("string" === typeof k && (c = k.split(" "), k = h[d] = c), void 0 !== k && g.add.apply(g, _toConsumableArray(k))), b.dir = d);
      Oc || (a.getWritable().__dir = d);
    }

    Qc = d;
    b.__lexicalDirTextContent = M;
    b.__lexicalDir = d;
  }
}

function hd(a, b) {
  var c = [];

  for (a = a.__first; null !== a;) {
    var d = b.get(a);
    void 0 === d && r(101);
    c.push(a);
    a = d.__next;
  }

  return c;
}

function sd(a, b) {
  var c = Tc.get(a),
      d = Uc.get(a);
  void 0 !== c && void 0 !== d || r(61);
  var e = Nc || Sc.has(a) || Rc.has(a);
  var f = vc(N, a);
  if (c === d && !e) return D(c) ? (d = f.__lexicalTextContent, void 0 !== d && (L += d, Kc += d), d = f.__lexicalDirTextContent, void 0 !== d && (M += d)) : (d = c.getTextContent(), B(c) && !c.isDirectionless() && (M += d), Kc += d, L += d), f;
  c !== d && e && rc(ed, Mc, Pc, d, "updated");
  if (d.updateDOM(c, f, Lc)) return d = md(a, null, null), null === b && r(62), b.replaceChild(d, f), fd(a, null), d;

  if (D(c) && D(d)) {
    a = d.__indent;
    a !== c.__indent && kd(f, a);
    a = d.__format;
    a !== c.__format && ld(f, a);

    if (e) {
      a = d;
      e = M;
      M = "";
      b = L;
      var g = c.__size,
          h = a.__size;
      L = "";

      if (1 === g && 1 === h) {
        var k = c.__first,
            m = a.__first;
        if (k === m) sd(k, f);else {
          var n = gd(k);
          m = md(m, null, null);
          f.replaceChild(m, n);
          fd(k, null);
        }
      } else {
        m = hd(c, Tc);
        var p = hd(a, Uc);
        if (0 === g) 0 !== h && nd(p, a, 0, h - 1, f, null);else if (0 === h) 0 !== g && (k = null == f.__lexicalLineBreak, id(m, 0, g - 1, k ? null : f), k && (f.textContent = ""));else {
          var l = m;
          m = p;
          p = g - 1;
          g = h - 1;
          var u = f.firstChild,
              x = 0;

          for (h = 0; x <= p && h <= g;) {
            var q = l[x];
            var y = m[h];
            if (q === y) u = td(sd(y, f)), x++, h++;else {
              void 0 === k && (k = new Set(l));
              void 0 === n && (n = new Set(m));
              var A = n.has(q),
                  Z = k.has(y);
              A ? (Z ? (q = vc(N, y), q === u ? u = td(sd(y, f)) : (null != u ? f.insertBefore(q, u) : f.appendChild(q), sd(y, f)), x++) : md(y, f, u), h++) : (u = td(gd(q)), fd(q, f), x++);
            }
          }

          k = x > p;
          n = h > g;
          k && !n ? (k = m[g + 1], k = void 0 === k ? null : N.getElementByKey(k), nd(m, a, h, g, f, k)) : n && !k && id(l, x, p, f);
        }
      }

      uc(a) && (L += "\n\n");
      f.__lexicalTextContent = L;
      L = b + L;
      od(a, f);
      M = e;
      K(d) || d.isInline() || pd(c, d, f);
    }

    uc(d) && (L += "\n\n", Kc += "\n\n");
  } else c = d.getTextContent(), z(d) ? (e = d.decorate(N, Lc), null !== e && qd(a, e)) : B(d) && !d.isDirectionless() && (M += c), L += c, Kc += c;

  !Oc && K(d) && d.__cachedText !== Kc && (d = d.getWritable(), d.__cachedText = Kc);
  return f;
}

function qd(a, b) {
  var c = N._pendingDecorators,
      d = N._decorators;

  if (null === c) {
    if (d[a] === b) return;
    c = fc(N);
  }

  c[a] = b;
}

function td(a) {
  a = a.nextSibling;
  null !== a && a === N._blockCursorElement && (a = a.nextSibling);
  return a;
}

function gd(a) {
  var b = Vc.get(a);
  void 0 === b && r(75, a);
  return b;
}

var ud = Object.freeze({}),
    Bd = [["keydown", vd], ["pointerdown", wd], ["compositionstart", xd], ["compositionend", yd], ["input", zd], ["click", Ad], ["cut", ud], ["copy", ud], ["dragstart", ud], ["dragover", ud], ["dragend", ud], ["paste", ud], ["focus", ud], ["blur", ud], ["drop", ud]];
Xa && Bd.push(["beforeinput", function (a, b) {
  return Cd(a, b);
}]);
var Dd = 0,
    Ed = 0,
    Fd = 0,
    Gd = null,
    Hd = 0,
    Id = !1,
    Jd = !1,
    Kd = !1,
    Ld = !1,
    Md = [0, "", 0, "root", 0];

function Nd(a, b, c, d, e) {
  var f = a.anchor,
      g = a.focus,
      h = f.getNode();
  var k = F();
  var m = vb(k._window),
      n = null !== m ? m.anchorNode : null,
      p = f.key;
  k = k.getElementByKey(p);
  var l = c.length;
  return p !== g.key || !B(h) || (!e && (!Xa || Fd < d + 50) || h.isDirty() && 2 > l || kc(c)) && f.offset !== g.offset && !h.isComposing() || Ob(h) || h.isDirty() && 1 < l || (e || !Xa) && null !== k && !h.isComposing() && n !== Vb(k) || null !== m && null !== b && (!b.collapsed || b.startContainer !== m.anchorNode || b.startOffset !== m.anchorOffset) || h.getFormat() !== a.format || h.getStyle() !== a.style || pc(a, h);
}

function Od(a, b) {
  return null !== a && null !== a.nodeValue && 3 === a.nodeType && 0 !== b && b !== a.nodeValue.length;
}

function Pd(a, b, c) {
  var d = a.anchorNode,
      e = a.anchorOffset,
      f = a.focusNode,
      g = a.focusOffset;
  if (Id && (Id = !1, Od(d, e) && Od(f, g))) return;
  w(b, function () {
    if (!c) yb(null);else if (Lb(b, d, f)) {
      var h = v();

      if (C(h)) {
        var k = h.anchor,
            m = k.getNode();

        if (h.isCollapsed()) {
          "Range" === a.type && a.anchorNode === a.focusNode && (h.dirty = !0);
          var n = Cb(b).event;
          n = n ? n.timeStamp : performance.now();

          var _Md = Md,
              _Md2 = _slicedToArray(_Md, 5),
              p = _Md2[0],
              l = _Md2[1],
              q = _Md2[2],
              u = _Md2[3],
              x = _Md2[4];

          n < x + 200 && k.offset === q && k.key === u ? (h.format = p, h.style = l) : "text" === k.type ? (h.format = m.getFormat(), h.style = m.getStyle()) : "element" === k.type && (h.format = 0, h.style = "");
        } else {
          k = 255;
          m = !1;
          n = h.getNodes();
          var _p = n.length;

          for (var _l = 0; _l < _p; _l++) {
            var _q = n[_l];
            if (B(_q) && (m = !0, k &= _q.getFormat(), 0 === k)) break;
          }

          h.format = m ? k : 0;
        }
      }

      O(b, aa, void 0);
    }
  });
}

function Ad(a, b) {
  w(b, function () {
    var c = v();
    var d = vb(b._window);
    var e = oc();
    if (d) if (C(c)) {
      var g = c.anchor;
      var f = g.getNode();
      "element" === g.type && 0 === g.offset && c.isCollapsed() && !K(f) && 1 === hc().getChildrenSize() && f.getTopLevelElementOrThrow().isEmpty() && null !== e && c.is(e) ? (d.removeAllRanges(), c.dirty = !0) : 3 !== a.detail || c.isCollapsed() || (d = c.focus.getNode(), f !== d && (D(f) ? f.select(0) : f.getParentOrThrow().select(0)));
    } else "touch" === a.pointerType && (f = d.anchorNode, null !== f && (f = f.nodeType, 1 === f || 3 === f)) && (d = Qd(e, d, b), yb(d));
    O(b, ba, a);
  });
}

function wd(a, b) {
  var c = a.target;
  a = a.pointerType;
  c instanceof Node && "touch" !== a && w(b, function () {
    z(ub(c)) || (Jd = !0);
  });
}

function Rd(a) {
  if (!a.getTargetRanges) return null;
  a = a.getTargetRanges();
  return 0 === a.length ? null : a[0];
}

function Sd(a, b) {
  return a !== b || D(a) || D(b) || !a.isToken() || !b.isToken();
}

function Cd(a, b) {
  var c = a.inputType,
      d = Rd(a);
  "deleteCompositionText" === c || Wa && zb(b) || "insertCompositionText" !== c && w(b, function () {
    var e = v();

    if ("deleteContentBackward" === c) {
      if (null === e) {
        var f = oc();
        if (!C(f)) return;
        yb(f.clone());
      }

      if (C(e)) {
        229 === Ed && a.timeStamp < Dd + 30 && b.isComposing() && e.anchor.key === e.focus.key ? (H(null), Dd = 0, setTimeout(function () {
          w(b, function () {
            H(null);
          });
        }, 30), C(e) && (f = e.anchor.getNode(), f.markDirty(), e.format = f.getFormat(), e.style = f.getStyle())) : (a.preventDefault(), O(b, da, !0));
        return;
      }
    }

    if (C(e)) {
      f = a.data;
      null !== Gd && nc(!1, b, Gd);
      e.dirty && null === Gd || !e.isCollapsed() || K(e.anchor.getNode()) || null === d || e.applyDOMRange(d);
      Gd = null;
      var g = e.focus,
          h = e.anchor.getNode();
      g = g.getNode();
      if ("insertText" === c || "insertTranspose" === c) "\n" === f ? (a.preventDefault(), O(b, ea, !1)) : "\n\n" === f ? (a.preventDefault(), O(b, fa, void 0)) : null == f && a.dataTransfer ? (f = a.dataTransfer.getData("text/plain"), a.preventDefault(), e.insertRawText(f)) : null != f && Nd(e, d, f, a.timeStamp, !0) ? (a.preventDefault(), O(b, ha, f)) : Gd = f, Fd = a.timeStamp;else switch (a.preventDefault(), c) {
        case "insertFromYank":
        case "insertFromDrop":
        case "insertReplacementText":
          O(b, ha, a);
          break;

        case "insertFromComposition":
          H(null);
          O(b, ha, a);
          break;

        case "insertLineBreak":
          H(null);
          O(b, ea, !1);
          break;

        case "insertParagraph":
          H(null);
          Kd && !Za ? (Kd = !1, O(b, ea, !1)) : O(b, fa, void 0);
          break;

        case "insertFromPaste":
        case "insertFromPasteAsQuotation":
          O(b, ka, a);
          break;

        case "deleteByComposition":
          Sd(h, g) && O(b, ma, a);
          break;

        case "deleteByDrag":
        case "deleteByCut":
          O(b, ma, a);
          break;

        case "deleteContent":
          O(b, da, !1);
          break;

        case "deleteWordBackward":
          O(b, na, !0);
          break;

        case "deleteWordForward":
          O(b, na, !1);
          break;

        case "deleteHardLineBackward":
        case "deleteSoftLineBackward":
          O(b, pa, !0);
          break;

        case "deleteContentForward":
        case "deleteHardLineForward":
        case "deleteSoftLineForward":
          O(b, pa, !1);
          break;

        case "formatStrikeThrough":
          O(b, qa, "strikethrough");
          break;

        case "formatBold":
          O(b, qa, "bold");
          break;

        case "formatItalic":
          O(b, qa, "italic");
          break;

        case "formatUnderline":
          O(b, qa, "underline");
          break;

        case "historyUndo":
          O(b, ra, void 0);
          break;

        case "historyRedo":
          O(b, sa, void 0);
      }
    }
  });
}

function zd(a, b) {
  a.stopPropagation();
  w(b, function () {
    var c = v(),
        d = a.data,
        e = Rd(a);

    if (null != d && C(c) && Nd(c, e, d, a.timeStamp, !1)) {
      Ld && (Td(b, d), Ld = !1);
      var f = c.anchor,
          g = f.getNode();
      e = vb(b._window);
      if (null === e) return;
      var h = f.offset;
      if (f = Xa && !c.isCollapsed() && B(g) && null !== e.anchorNode) g = g.getTextContent().slice(0, h) + d + g.getTextContent().slice(h + c.focus.offset), e = e.anchorNode, f = g === (3 === e.nodeType ? e.nodeValue : null);
      f || O(b, ha, d);
      d = d.length;
      Wa && 1 < d && "insertCompositionText" === a.inputType && !b.isComposing() && (c.anchor.offset -= d);
      Ya || Za || ab || !b.isComposing() || (Dd = 0, H(null));
    } else nc(!1, b, null !== d ? d : void 0), Ld && (Td(b, d || void 0), Ld = !1);

    G();
    c = F();
    Ab(c);
  });
  Gd = null;
}

function xd(a, b) {
  w(b, function () {
    var c = v();

    if (C(c) && !b.isComposing()) {
      var d = c.anchor,
          e = c.anchor.getNode();
      H(d.key);
      (a.timeStamp < Dd + 30 || "element" === d.type || !c.isCollapsed() || e.getFormat() !== c.format || e.getStyle() !== c.style) && O(b, ha, cb);
    }
  });
}

function Td(a, b) {
  var c = a._compositionKey;
  H(null);

  if (null !== c && null != b) {
    if ("" === b) {
      b = I(c);
      a = Vb(a.getElementByKey(c));
      null !== a && null !== a.nodeValue && B(b) && wb(b, a.nodeValue, null, null, !0);
      return;
    }

    if ("\n" === b[b.length - 1] && (c = v(), C(c))) {
      b = c.focus;
      c.anchor.set(b.key, b.offset, b.type);
      O(a, Ba, null);
      return;
    }
  }

  nc(!0, a, b);
}

function yd(a, b) {
  Wa ? Ld = !0 : w(b, function () {
    Td(b, a.data);
  });
}

function vd(a, b) {
  Dd = a.timeStamp;
  Ed = a.keyCode;

  if (!b.isComposing()) {
    var c = a.keyCode,
        d = a.shiftKey,
        e = a.ctrlKey,
        f = a.metaKey,
        g = a.altKey;

    if (!O(b, ta, a)) {
      if (39 !== c || e || f || g) {
        if (39 !== c || g || d || !e && !f) {
          if (37 !== c || e || f || g) {
            if (37 !== c || g || d || !e && !f) {
              if (38 !== c || e || f) {
                if (40 !== c || e || f) {
                  if (13 === c && d) Kd = !0, O(b, Ba, a);else if (32 === c) O(b, Ca, a);else if (t && e && 79 === c) a.preventDefault(), Kd = !0, O(b, ea, !0);else if (13 !== c || d) {
                    var h = t ? g || f ? !1 : 8 === c || 72 === c && e : e || g || f ? !1 : 8 === c;
                    h ? 8 === c ? O(b, Fa, a) : (a.preventDefault(), O(b, da, !0)) : 27 === c ? O(b, Ga, a) : (h = t ? d || g || f ? !1 : 46 === c || 68 === c && e : e || g || f ? !1 : 46 === c, h ? 46 === c ? O(b, Ha, a) : (a.preventDefault(), O(b, da, !1)) : 8 === c && (t ? g : e) ? (a.preventDefault(), O(b, na, !0)) : 46 === c && (t ? g : e) ? (a.preventDefault(), O(b, na, !1)) : t && f && 8 === c ? (a.preventDefault(), O(b, pa, !0)) : t && f && 46 === c ? (a.preventDefault(), O(b, pa, !1)) : 66 === c && !g && (t ? f : e) ? (a.preventDefault(), O(b, qa, "bold")) : 85 === c && !g && (t ? f : e) ? (a.preventDefault(), O(b, qa, "underline")) : 73 === c && !g && (t ? f : e) ? (a.preventDefault(), O(b, qa, "italic")) : 9 !== c || g || e || f ? 90 === c && !d && (t ? f : e) ? (a.preventDefault(), O(b, ra, void 0)) : (h = t ? 90 === c && f && d : 89 === c && e || 90 === c && e && d, h ? (a.preventDefault(), O(b, sa, void 0)) : Ud(b._editorState._selection) ? (h = d ? !1 : 67 === c ? t ? f : e : !1, h ? (a.preventDefault(), O(b, Na, a)) : (h = d ? !1 : 88 === c ? t ? f : e : !1, h ? (a.preventDefault(), O(b, Oa, a)) : 65 === c && (t ? f : e) && (a.preventDefault(), O(b, Pa, a)))) : !Wa && 65 === c && (t ? f : e) && (a.preventDefault(), O(b, Pa, a))) : O(b, Ia, a));
                  } else Kd = !1, O(b, Ba, a);
                } else O(b, Aa, a);
              } else O(b, za, a);
            } else O(b, ya, a);
          } else O(b, xa, a);
        } else O(b, va, a);
      } else O(b, ua, a);
      (e || d || g || f) && O(b, Sa, a);
    }
  }
}

function Vd(a) {
  var b = a.__lexicalEventHandles;
  void 0 === b && (b = [], a.__lexicalEventHandles = b);
  return b;
}

var Wd = new Map();

function Xd(a) {
  a = a.target;
  var b = vb(null == a ? null : 9 === a.nodeType ? a.defaultView : a.ownerDocument.defaultView);

  if (null !== b) {
    var c = Mb(b.anchorNode);

    if (null !== c) {
      Jd && (Jd = !1, w(c, function () {
        var g = oc(),
            h = b.anchorNode;
        null !== h && (h = h.nodeType, 1 === h || 3 === h) && (g = Qd(g, b, c), yb(g));
      }));
      a = lc(c);
      a = a[a.length - 1];
      var d = a._key,
          e = Wd.get(d),
          f = e || a;
      f !== c && Pd(b, f, !1);
      Pd(b, c, !0);
      c !== a ? Wd.set(d, c) : e && Wd.delete(d);
    }
  }
}

function Yd(a, b) {
  0 === Hd && a.ownerDocument.addEventListener("selectionchange", Xd);
  Hd++;
  a.__lexicalEditor = b;
  var c = Vd(a);

  var _loop = function _loop(d) {
    var _Bd$d = _slicedToArray(Bd[d], 2),
        e = _Bd$d[0],
        f = _Bd$d[1],
        g = "function" === typeof f ? function (h) {
      !0 !== h._lexicalHandled && (h._lexicalHandled = !0, b.isEditable() && f(h, b));
    } : function (h) {
      if (!0 !== h._lexicalHandled && (h._lexicalHandled = !0, b.isEditable())) switch (e) {
        case "cut":
          return O(b, Oa, h);

        case "copy":
          return O(b, Na, h);

        case "paste":
          return O(b, ka, h);

        case "dragstart":
          return O(b, Ka, h);

        case "dragover":
          return O(b, La, h);

        case "dragend":
          return O(b, Ma, h);

        case "focus":
          return O(b, Qa, h);

        case "blur":
          return O(b, Ra, h);

        case "drop":
          return O(b, Ja, h);
      }
    };

    a.addEventListener(e, g);
    c.push(function () {
      a.removeEventListener(e, g);
    });
  };

  for (var d = 0; d < Bd.length; d++) {
    _loop(d);
  }
}

function Zd(a, b, c) {
  G();
  var d = a.__key;
  var e = a.getParent();

  if (null !== e) {
    var f = v();

    if (C(f) && D(a)) {
      var _f3 = f,
          g = _f3.anchor,
          h = _f3.focus;
      var k = g.getNode();
      var m = h.getNode();
      wc(k, a) && g.set(a.__key, 0, "element");
      wc(m, a) && h.set(a.__key, 0, "element");
    }

    k = f;
    m = !1;

    if (C(k) && b) {
      f = k.anchor;
      var n = k.focus;
      f.key === d && ($d(f, a, e, a.getPreviousSibling(), a.getNextSibling()), m = !0);
      n.key === d && ($d(n, a, e, a.getPreviousSibling(), a.getNextSibling()), m = !0);
    } else Ud(k) && b && a.isSelected() && a.selectPrevious();

    C(k) && b && !m ? (d = a.getIndexWithinParent(), bc(a), ae(k, e, d, -1)) : bc(a);
    c || yc(e) || e.canBeEmpty() || !e.isEmpty() || Zd(e, b);
    b && K(e) && e.isEmpty() && e.selectEnd();
  }
}

var be = /*#__PURE__*/function () {
  function be(a) {
    _classCallCheck(this, be);

    this.__type = this.constructor.getType();
    this.__next = this.__prev = this.__parent = null;
    Zb(this, a);
  }

  _createClass(be, [{
    key: "getType",
    value: function getType() {
      return this.__type;
    }
  }, {
    key: "isAttached",
    value: function isAttached() {
      for (var a = this.__key; null !== a;) {
        if ("root" === a) return !0;
        a = I(a);
        if (null === a) break;
        a = a.__parent;
      }

      return !1;
    }
  }, {
    key: "isSelected",
    value: function isSelected(a) {
      var _this = this;

      a = a || v();
      if (null == a) return !1;
      var b = a.getNodes().some(function (c) {
        return c.__key === _this.__key;
      });
      return B(this) ? b : C(a) && "element" === a.anchor.type && "element" === a.focus.type && a.anchor.key === a.focus.key && a.anchor.offset === a.focus.offset ? !1 : b;
    }
  }, {
    key: "getKey",
    value: function getKey() {
      return this.__key;
    }
  }, {
    key: "getIndexWithinParent",
    value: function getIndexWithinParent() {
      var a = this.getParent();
      if (null === a) return -1;
      a = a.getFirstChild();
      var b = 0;

      for (; null !== a;) {
        if (this.is(a)) return b;
        b++;
        a = a.getNextSibling();
      }

      return -1;
    }
  }, {
    key: "getParent",
    value: function getParent() {
      var a = this.getLatest().__parent;

      return null === a ? null : I(a);
    }
  }, {
    key: "getParentOrThrow",
    value: function getParentOrThrow() {
      var a = this.getParent();
      null === a && r(66, this.__key);
      return a;
    }
  }, {
    key: "getTopLevelElement",
    value: function getTopLevelElement() {
      var a = this;

      for (; null !== a;) {
        var b = a.getParent();
        if (yc(b)) return a;
        a = b;
      }

      return null;
    }
  }, {
    key: "getTopLevelElementOrThrow",
    value: function getTopLevelElementOrThrow() {
      var a = this.getTopLevelElement();
      null === a && r(67, this.__key);
      return a;
    }
  }, {
    key: "getParents",
    value: function getParents() {
      var a = [],
          b = this.getParent();

      for (; null !== b;) {
        a.push(b), b = b.getParent();
      }

      return a;
    }
  }, {
    key: "getParentKeys",
    value: function getParentKeys() {
      var a = [],
          b = this.getParent();

      for (; null !== b;) {
        a.push(b.__key), b = b.getParent();
      }

      return a;
    }
  }, {
    key: "getPreviousSibling",
    value: function getPreviousSibling() {
      var a = this.getLatest().__prev;

      return null === a ? null : I(a);
    }
  }, {
    key: "getPreviousSiblings",
    value: function getPreviousSiblings() {
      var a = [];
      var b = this.getParent();
      if (null === b) return a;

      for (b = b.getFirstChild(); null !== b && !b.is(this);) {
        a.push(b), b = b.getNextSibling();
      }

      return a;
    }
  }, {
    key: "getNextSibling",
    value: function getNextSibling() {
      var a = this.getLatest().__next;

      return null === a ? null : I(a);
    }
  }, {
    key: "getNextSiblings",
    value: function getNextSiblings() {
      var a = [],
          b = this.getNextSibling();

      for (; null !== b;) {
        a.push(b), b = b.getNextSibling();
      }

      return a;
    }
  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor(a) {
      var b = this.getParents();
      var c = a.getParents();
      D(this) && b.unshift(this);
      D(a) && c.unshift(a);
      a = b.length;
      var d = c.length;
      if (0 === a || 0 === d || b[a - 1] !== c[d - 1]) return null;
      c = new Set(c);

      for (d = 0; d < a; d++) {
        var e = b[d];
        if (c.has(e)) return e;
      }

      return null;
    }
  }, {
    key: "is",
    value: function is(a) {
      return null == a ? !1 : this.__key === a.__key;
    }
  }, {
    key: "isBefore",
    value: function isBefore(a) {
      if (this === a) return !1;
      if (a.isParentOf(this)) return !0;
      if (this.isParentOf(a)) return !1;
      var b = this.getCommonAncestor(a);
      var c = this;

      for (;;) {
        var d = c.getParentOrThrow();

        if (d === b) {
          d = c.getIndexWithinParent();
          break;
        }

        c = d;
      }

      for (c = a;;) {
        a = c.getParentOrThrow();

        if (a === b) {
          b = c.getIndexWithinParent();
          break;
        }

        c = a;
      }

      return d < b;
    }
  }, {
    key: "isParentOf",
    value: function isParentOf(a) {
      var b = this.__key;
      if (b === a.__key) return !1;

      for (; null !== a;) {
        if (a.__key === b) return !0;
        a = a.getParent();
      }

      return !1;
    }
  }, {
    key: "getNodesBetween",
    value: function getNodesBetween(a) {
      var b = this.isBefore(a),
          c = [],
          d = new Set();

      for (var e = this;;) {
        var f = e.__key;
        d.has(f) || (d.add(f), c.push(e));
        if (e === a) break;
        f = D(e) ? b ? e.getFirstChild() : e.getLastChild() : null;
        if (null !== f) e = f;else if (f = b ? e.getNextSibling() : e.getPreviousSibling(), null !== f) e = f;else {
          e = e.getParentOrThrow();
          d.has(e.__key) || c.push(e);
          if (e === a) break;
          f = e;

          do {
            null === f && r(68), e = b ? f.getNextSibling() : f.getPreviousSibling(), f = f.getParent(), null !== f && (null !== e || d.has(f.__key) || c.push(f));
          } while (null === e);
        }
      }

      b || c.reverse();
      return c;
    }
  }, {
    key: "isDirty",
    value: function isDirty() {
      var a = F()._dirtyLeaves;

      return null !== a && a.has(this.__key);
    }
  }, {
    key: "getLatest",
    value: function getLatest() {
      var a = I(this.__key);
      null === a && r(113);
      return a;
    }
  }, {
    key: "getWritable",
    value: function getWritable() {
      G();
      var a = ac(),
          b = F();
      a = a._nodeMap;
      var c = this.__key,
          d = this.getLatest(),
          e = d.__parent;
      b = b._cloneNotNeeded;
      var f = v();
      null !== f && (f._cachedNodes = null);
      if (b.has(c)) return cc(d), d;
      f = d.constructor.clone(d);
      f.__parent = e;
      f.__next = d.__next;
      f.__prev = d.__prev;
      D(d) && D(f) ? (f.__first = d.__first, f.__last = d.__last, f.__size = d.__size, f.__indent = d.__indent, f.__format = d.__format, f.__dir = d.__dir) : B(d) && B(f) && (f.__format = d.__format, f.__style = d.__style, f.__mode = d.__mode, f.__detail = d.__detail);
      b.add(c);
      f.__key = c;
      cc(f);
      a.set(c, f);
      return f;
    }
  }, {
    key: "getTextContent",
    value: function getTextContent() {
      return "";
    }
  }, {
    key: "getTextContentSize",
    value: function getTextContentSize() {
      return this.getTextContent().length;
    }
  }, {
    key: "createDOM",
    value: function createDOM() {
      r(70);
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      r(71);
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(a) {
      return {
        element: this.createDOM(a._config, a)
      };
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      r(72);
    }
  }, {
    key: "remove",
    value: function remove(a) {
      Zd(this, !0, a);
    }
  }, {
    key: "replace",
    value: function replace(a, b) {
      G();
      var c = v();
      null !== c && (c = c.clone());
      Bc(this, a);
      var d = this.getLatest(),
          e = this.__key,
          f = a.__key,
          g = a.getWritable();
      a = this.getParentOrThrow().getWritable();
      var h = a.__size;
      bc(g);
      var k = d.getPreviousSibling(),
          m = d.getNextSibling(),
          n = d.__prev,
          p = d.__next,
          l = d.__parent;
      Zd(d, !1, !0);
      null === k ? a.__first = f : k.getWritable().__next = f;
      g.__prev = n;
      null === m ? a.__last = f : m.getWritable().__prev = f;
      g.__next = p;
      g.__parent = l;
      a.__size = h;
      b && this.getChildren().forEach(function (q) {
        g.append(q);
      });
      C(c) && (yb(c), b = c.anchor, c = c.focus, b.key === e && ce(b, g), c.key === e && ce(c, g));
      dc() === e && H(f);
      return g;
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      G();
      Bc(this, a);
      var c = this.getWritable();
      var d = a.getWritable();
      var e = d.getParent();
      var f = v();
      var g = !1,
          h = !1;

      if (null !== e) {
        var k = a.getIndexWithinParent();
        bc(d);
        C(f) && (h = e.__key, g = f.anchor, e = f.focus, g = "element" === g.type && g.key === h && g.offset === k + 1, h = "element" === e.type && e.key === h && e.offset === k + 1);
      }

      e = this.getNextSibling();
      k = this.getParentOrThrow().getWritable();
      var m = d.__key,
          n = c.__next;
      null === e ? k.__last = m : e.getWritable().__prev = m;
      k.__size++;
      c.__next = m;
      d.__next = n;
      d.__prev = c.__key;
      d.__parent = c.__parent;
      b && C(f) && (b = this.getIndexWithinParent(), ae(f, k, b + 1), c = k.__key, g && f.anchor.set(c, b + 2, "element"), h && f.focus.set(c, b + 2, "element"));
      return a;
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      G();
      Bc(this, a);
      var c = this.getWritable();
      var d = a.getWritable(),
          e = d.__key;
      bc(d);
      var f = this.getPreviousSibling(),
          g = this.getParentOrThrow().getWritable(),
          h = c.__prev,
          k = this.getIndexWithinParent();
      null === f ? g.__first = e : f.getWritable().__next = e;
      g.__size++;
      c.__prev = e;
      d.__prev = h;
      d.__next = c.__key;
      d.__parent = c.__parent;
      c = v();
      b && C(c) && (b = this.getParentOrThrow(), ae(c, b, k));
      return a;
    }
  }, {
    key: "isParentRequired",
    value: function isParentRequired() {
      return !1;
    }
  }, {
    key: "createParentElementNode",
    value: function createParentElementNode() {
      return de();
    }
  }, {
    key: "selectPrevious",
    value: function selectPrevious(a, b) {
      G();
      var c = this.getPreviousSibling(),
          d = this.getParentOrThrow();
      return null === c ? d.select(0, 0) : D(c) ? c.select() : B(c) ? c.select(a, b) : (a = c.getIndexWithinParent() + 1, d.select(a, a));
    }
  }, {
    key: "selectNext",
    value: function selectNext(a, b) {
      G();
      var c = this.getNextSibling(),
          d = this.getParentOrThrow();
      return null === c ? d.select() : D(c) ? c.select(0, 0) : B(c) ? c.select(a, b) : (a = c.getIndexWithinParent(), d.select(a, a));
    }
  }, {
    key: "markDirty",
    value: function markDirty() {
      this.getWritable();
    }
  }], [{
    key: "getType",
    value: function getType() {
      r(64, this.name);
    }
  }, {
    key: "clone",
    value: function clone() {
      r(65, this.name);
    }
  }, {
    key: "importJSON",
    value: function importJSON() {
      r(18, this.name);
    }
  }, {
    key: "transform",
    value: function transform() {
      return null;
    }
  }]);

  return be;
}();

var ee = /*#__PURE__*/function (_be) {
  _inherits(ee, _be);

  var _super = _createSuper(ee);

  function ee(a) {
    _classCallCheck(this, ee);

    return _super.call(this, a);
  }

  _createClass(ee, [{
    key: "getTextContent",
    value: function getTextContent() {
      return "\n";
    }
  }, {
    key: "createDOM",
    value: function createDOM() {
      return document.createElement("br");
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return !1;
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return {
        type: "linebreak",
        version: 1
      };
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "linebreak";
    }
  }, {
    key: "clone",
    value: function clone(a) {
      return new ee(a.__key);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        br: function br(a) {
          var b = a.parentElement,
              c,
              d;
          return null !== b && ((c = b.firstChild) === a || c.nextSibling === a && 3 === c.nodeType && null !== (c.textContent || "").match(/^( |\t|\r?\n)+$/)) && ((d = b.lastChild) === a || d.previousSibling === a && 3 === d.nodeType && null !== (d.textContent || "").match(/^( |\t|\r?\n)+$/)) ? null : {
            conversion: fe,
            priority: 0
          };
        }
      };
    }
  }, {
    key: "importJSON",
    value: function importJSON() {
      return ge();
    }
  }]);

  return ee;
}(be);

function fe() {
  return {
    node: ge()
  };
}

function ge() {
  return Ac(new ee());
}

function Yb(a) {
  return a instanceof ee;
}

function he(a, b) {
  return b & 16 ? "code" : b & 128 ? "mark" : b & 32 ? "sub" : b & 64 ? "sup" : null;
}

function ie(a, b) {
  return b & 1 ? "strong" : b & 2 ? "em" : "span";
}

function je(a, b, c, d, e) {
  var _a, _a2, _a3;

  a = d.classList;
  d = qc(e, "base");
  void 0 !== d && (_a = a).add.apply(_a, _toConsumableArray(d));
  d = qc(e, "underlineStrikethrough");
  var f = !1,
      g = b & 8 && b & 4;
  var h = c & 8 && c & 4;
  void 0 !== d && (h ? (f = !0, g || (_a2 = a).add.apply(_a2, _toConsumableArray(d))) : g && (_a3 = a).remove.apply(_a3, _toConsumableArray(d)));

  for (var k in fb) {
    var _a4, _a5, _a6;

    h = fb[k], d = qc(e, k), void 0 !== d && (c & h ? !f || "underline" !== k && "strikethrough" !== k ? (0 === (b & h) || g && "underline" === k || "strikethrough" === k) && (_a4 = a).add.apply(_a4, _toConsumableArray(d)) : b & h && (_a5 = a).remove.apply(_a5, _toConsumableArray(d)) : b & h && (_a6 = a).remove.apply(_a6, _toConsumableArray(d)));
  }
}

function ke(a, b, c) {
  var d = b.firstChild;
  c = c.isComposing();
  a += c ? bb : "";
  if (null == d) b.textContent = a;else if (b = d.nodeValue, b !== a) if (c || Wa) {
    c = b.length;
    var e = a.length,
        f = 0,
        g = 0;

    for (; f < c && f < e && b[f] === a[f];) {
      f++;
    }

    for (; g + f < c && g + f < e && b[c - g - 1] === a[e - g - 1];) {
      g++;
    }

    a = [f, c - f - g, a.slice(f, e - g)];

    var _a7 = a,
        _a8 = _slicedToArray(_a7, 3),
        h = _a8[0],
        k = _a8[1],
        m = _a8[2];

    0 !== k && d.deleteData(h, k);
    d.insertData(h, m);
  } else d.nodeValue = a;
}

function le(a, b) {
  b = document.createElement(b);
  b.appendChild(a);
  return b;
}

var me = /*#__PURE__*/function (_be2) {
  _inherits(me, _be2);

  var _super2 = _createSuper(me);

  function me(a, b) {
    var _this2;

    _classCallCheck(this, me);

    _this2 = _super2.call(this, b);
    _this2.__text = a;
    _this2.__format = 0;
    _this2.__style = "";
    _this2.__detail = _this2.__mode = 0;
    return _this2;
  }

  _createClass(me, [{
    key: "getFormat",
    value: function getFormat() {
      return this.getLatest().__format;
    }
  }, {
    key: "getDetail",
    value: function getDetail() {
      return this.getLatest().__detail;
    }
  }, {
    key: "getMode",
    value: function getMode() {
      var a = this.getLatest();
      return kb[a.__mode];
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      return this.getLatest().__style;
    }
  }, {
    key: "isToken",
    value: function isToken() {
      return 1 === this.getLatest().__mode;
    }
  }, {
    key: "isComposing",
    value: function isComposing() {
      return this.__key === dc();
    }
  }, {
    key: "isSegmented",
    value: function isSegmented() {
      return 2 === this.getLatest().__mode;
    }
  }, {
    key: "isDirectionless",
    value: function isDirectionless() {
      return 0 !== (this.getLatest().__detail & 1);
    }
  }, {
    key: "isUnmergeable",
    value: function isUnmergeable() {
      return 0 !== (this.getLatest().__detail & 2);
    }
  }, {
    key: "hasFormat",
    value: function hasFormat(a) {
      a = fb[a];
      return 0 !== (this.getFormat() & a);
    }
  }, {
    key: "isSimpleText",
    value: function isSimpleText() {
      return "text" === this.__type && 0 === this.__mode;
    }
  }, {
    key: "getTextContent",
    value: function getTextContent() {
      return this.getLatest().__text;
    }
  }, {
    key: "getFormatFlags",
    value: function getFormatFlags(a, b) {
      var c = this.getLatest().__format;

      return Wb(c, a, b);
    }
  }, {
    key: "createDOM",
    value: function createDOM(a) {
      var b = this.__format,
          c = he(this, b);
      var d = ie(this, b),
          e = document.createElement(null === c ? d : c),
          f = e;
      this.hasFormat("code") && e.setAttribute("spellcheck", "false");
      null !== c && (f = document.createElement(d), e.appendChild(f));
      c = f;
      ke(this.__text, c, this);
      a = a.theme.text;
      void 0 !== a && je(d, 0, b, c, a);
      b = this.__style;
      "" !== b && (e.style.cssText = b);
      return e;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM(a, b, c) {
      var d = this.__text;
      var e = a.__format,
          f = this.__format,
          g = he(this, e);
      var h = he(this, f);
      var k = ie(this, e);
      var m = ie(this, f);
      if ((null === g ? k : g) !== (null === h ? m : h)) return !0;
      if (g === h && k !== m) return e = b.firstChild, null == e && r(48), a = g = document.createElement(m), ke(d, a, this), c = c.theme.text, void 0 !== c && je(m, 0, f, a, c), b.replaceChild(g, e), !1;
      k = b;
      null !== h && null !== g && (k = b.firstChild, null == k && r(49));
      ke(d, k, this);
      c = c.theme.text;
      void 0 !== c && e !== f && je(m, e, f, k, c);
      f = this.__style;
      a.__style !== f && (b.style.cssText = f);
      return !1;
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(a) {
      var _get$call = _get(_getPrototypeOf(me.prototype), "exportDOM", this).call(this, a);

      a = _get$call.element;
      null !== a && Hc(a) || r(132);
      a.style.whiteSpace = "pre-wrap";
      this.hasFormat("bold") && (a = le(a, "b"));
      this.hasFormat("italic") && (a = le(a, "i"));
      this.hasFormat("strikethrough") && (a = le(a, "s"));
      this.hasFormat("underline") && (a = le(a, "u"));
      return {
        element: a
      };
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return {
        detail: this.getDetail(),
        format: this.getFormat(),
        mode: this.getMode(),
        style: this.getStyle(),
        text: this.getTextContent(),
        type: "text",
        version: 1
      };
    }
  }, {
    key: "selectionTransform",
    value: function selectionTransform() {}
  }, {
    key: "setFormat",
    value: function setFormat(a) {
      var b = this.getWritable();
      b.__format = "string" === typeof a ? fb[a] : a;
      return b;
    }
  }, {
    key: "setDetail",
    value: function setDetail(a) {
      var b = this.getWritable();
      b.__detail = "string" === typeof a ? gb[a] : a;
      return b;
    }
  }, {
    key: "setStyle",
    value: function setStyle(a) {
      var b = this.getWritable();
      b.__style = a;
      return b;
    }
  }, {
    key: "toggleFormat",
    value: function toggleFormat(a) {
      a = fb[a];
      return this.setFormat(this.getFormat() ^ a);
    }
  }, {
    key: "toggleDirectionless",
    value: function toggleDirectionless() {
      var a = this.getWritable();
      a.__detail ^= 1;
      return a;
    }
  }, {
    key: "toggleUnmergeable",
    value: function toggleUnmergeable() {
      var a = this.getWritable();
      a.__detail ^= 2;
      return a;
    }
  }, {
    key: "setMode",
    value: function setMode(a) {
      a = jb[a];
      if (this.__mode === a) return this;
      var b = this.getWritable();
      b.__mode = a;
      return b;
    }
  }, {
    key: "setTextContent",
    value: function setTextContent(a) {
      if (this.__text === a) return this;
      var b = this.getWritable();
      b.__text = a;
      return b;
    }
  }, {
    key: "select",
    value: function select(a, b) {
      G();
      var c = v();
      var d = this.getTextContent();
      var e = this.__key;
      "string" === typeof d ? (d = d.length, void 0 === a && (a = d), void 0 === b && (b = d)) : b = a = 0;
      if (C(c)) d = dc(), d !== c.anchor.key && d !== c.focus.key || H(e), c.setTextNodeRange(this, a, this, b);else return re(e, a, e, b, "text", "text");
      return c;
    }
  }, {
    key: "spliceText",
    value: function spliceText(a, b, c, d) {
      var e = this.getWritable(),
          f = e.__text,
          g = c.length,
          h = a;
      0 > h && (h = g + h, 0 > h && (h = 0));
      var k = v();
      d && C(k) && (a += g, k.setTextNodeRange(e, a, e, a));
      b = f.slice(0, h) + c + f.slice(h + b);
      e.__text = b;
      return e;
    }
  }, {
    key: "canInsertTextBefore",
    value: function canInsertTextBefore() {
      return !0;
    }
  }, {
    key: "canInsertTextAfter",
    value: function canInsertTextAfter() {
      return !0;
    }
  }, {
    key: "splitText",
    value: function splitText() {
      for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
        a[_key] = arguments[_key];
      }

      G();
      var b = this.getLatest(),
          c = b.getTextContent(),
          d = b.__key,
          e = dc(),
          f = new Set(a);
      a = [];
      var g = c.length,
          h = "";

      for (var k = 0; k < g; k++) {
        "" !== h && f.has(k) && (a.push(h), h = ""), h += c[k];
      }

      "" !== h && a.push(h);
      f = a.length;
      if (0 === f) return [];
      if (a[0] === c) return [b];
      var m = a[0];
      c = b.getParentOrThrow();
      k = b.getFormat();
      var n = b.getStyle(),
          p = b.__detail;
      g = !1;
      b.isSegmented() ? (h = J(m), h.__format = k, h.__style = n, h.__detail = p, g = !0) : (h = b.getWritable(), h.__text = m);
      b = v();
      h = [h];
      m = m.length;

      for (var u = 1; u < f; u++) {
        var l = a[u],
            q = l.length;
        l = J(l).getWritable();
        l.__format = k;
        l.__style = n;
        l.__detail = p;
        var x = l.__key;
        q = m + q;

        if (C(b)) {
          var y = b.anchor,
              A = b.focus;
          y.key === d && "text" === y.type && y.offset > m && y.offset <= q && (y.key = x, y.offset -= m, b.dirty = !0);
          A.key === d && "text" === A.type && A.offset > m && A.offset <= q && (A.key = x, A.offset -= m, b.dirty = !0);
        }

        e === d && H(x);
        m = q;
        h.push(l);
      }

      d = this.getPreviousSibling();
      e = this.getNextSibling();
      null !== d && cc(d);
      null !== e && cc(e);
      d = c.getWritable();
      e = this.getIndexWithinParent();
      g ? (d.splice(e, 0, h), this.remove()) : d.splice(e, 1, h);
      C(b) && ae(b, c, e, f - 1);
      return h;
    }
  }, {
    key: "mergeWithSibling",
    value: function mergeWithSibling(a) {
      var b = a === this.getPreviousSibling();
      b || a === this.getNextSibling() || r(50);
      var c = this.__key;
      var d = a.__key,
          e = this.__text,
          f = e.length;
      dc() === d && H(c);
      var g = v();

      if (C(g)) {
        var h = g.anchor,
            k = g.focus;
        null !== h && h.key === d && (se(h, b, c, a, f), g.dirty = !0);
        null !== k && k.key === d && (se(k, b, c, a, f), g.dirty = !0);
      }

      c = a.__text;
      this.setTextContent(b ? c + e : e + c);
      b = this.getWritable();
      a.remove();
      return b;
    }
  }, {
    key: "isTextEntity",
    value: function isTextEntity() {
      return !1;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "text";
    }
  }, {
    key: "clone",
    value: function clone(a) {
      return new me(a.__text, a.__key);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        "#text": function text() {
          return {
            conversion: ne,
            priority: 0
          };
        },
        b: function b() {
          return {
            conversion: oe,
            priority: 0
          };
        },
        code: function code() {
          return {
            conversion: pe,
            priority: 0
          };
        },
        em: function em() {
          return {
            conversion: pe,
            priority: 0
          };
        },
        i: function i() {
          return {
            conversion: pe,
            priority: 0
          };
        },
        s: function s() {
          return {
            conversion: pe,
            priority: 0
          };
        },
        span: function span() {
          return {
            conversion: qe,
            priority: 0
          };
        },
        strong: function strong() {
          return {
            conversion: pe,
            priority: 0
          };
        },
        sub: function sub() {
          return {
            conversion: pe,
            priority: 0
          };
        },
        sup: function sup() {
          return {
            conversion: pe,
            priority: 0
          };
        },
        u: function u() {
          return {
            conversion: pe,
            priority: 0
          };
        }
      };
    }
  }, {
    key: "importJSON",
    value: function importJSON(a) {
      var b = J(a.text);
      b.setFormat(a.format);
      b.setDetail(a.detail);
      b.setMode(a.mode);
      b.setStyle(a.style);
      return b;
    }
  }]);

  return me;
}(be);

function qe(a) {
  var b = "700" === a.style.fontWeight,
      c = "line-through" === a.style.textDecoration,
      d = "italic" === a.style.fontStyle,
      e = "underline" === a.style.textDecoration,
      f = a.style.verticalAlign;
  return {
    forChild: function forChild(g) {
      if (!B(g)) return g;
      b && g.toggleFormat("bold");
      c && g.toggleFormat("strikethrough");
      d && g.toggleFormat("italic");
      e && g.toggleFormat("underline");
      "sub" === f && g.toggleFormat("subscript");
      "super" === f && g.toggleFormat("superscript");
      return g;
    },
    node: null
  };
}

function oe(a) {
  var b = "normal" === a.style.fontWeight;
  return {
    forChild: function forChild(c) {
      B(c) && !b && c.toggleFormat("bold");
      return c;
    },
    node: null
  };
}

var te = new WeakMap();

function ne(a) {
  null === a.parentElement && r(129);

  for (var b = a.textContent || "", c, d = a.parentNode, e = [a]; null !== d && void 0 === (c = te.get(d)) && !("PRE" === d.nodeName || 1 === d.nodeType && d.style.whiteSpace.startsWith("pre"));) {
    e.push(d), d = d.parentNode;
  }

  c = void 0 === c ? d : c;

  for (d = 0; d < e.length; d++) {
    te.set(e[d], c);
  }

  if (null !== c) {
    b = b.split(/(\r?\n|\t)/);
    a = [];
    e = b.length;

    for (c = 0; c < e; c++) {
      d = b[c], "\n" === d || "\r\n" === d ? a.push(ge()) : "\t" === d ? a.push(ue()) : "" !== d && a.push(J(d));
    }

    return {
      node: a
    };
  }

  b = b.replace(/\r/g, "").replace(/[ \t\n]+/g, " ");
  if ("" === b) return {
    node: null
  };

  if (" " === b[0]) {
    e = a;

    for (c = !0; null !== e && null !== (e = ve(e, !1));) {
      if (d = e.textContent || "", 0 < d.length) {
        /[ \t\n]$/.test(d) && (b = b.slice(1));
        c = !1;
        break;
      }
    }

    c && (b = b.slice(1));
  }

  if (" " === b[b.length - 1]) {
    for (e = !0; null !== a && null !== (a = ve(a, !0));) {
      if (0 < (a.textContent || "").replace(/^( |\t|\r?\n)+/, "").length) {
        e = !1;
        break;
      }
    }

    e && (b = b.slice(0, b.length - 1));
  }

  return "" === b ? {
    node: null
  } : {
    node: J(b)
  };
}

var we = new RegExp(/^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/, "i");

function ve(a, b) {
  for (;;) {
    for (var c = void 0; null === (c = b ? a.nextSibling : a.previousSibling);) {
      if (a = a.parentElement, null === a) return null;
    }

    a = c;
    if (1 === a.nodeType && (c = a.style.display, "" === c && null === a.nodeName.match(we) || "" !== c && !c.startsWith("inline"))) return null;

    for (; null !== (c = b ? a.firstChild : a.lastChild);) {
      a = c;
    }

    if (3 === a.nodeType) return a;
    if ("BR" === a.nodeName) return null;
  }
}

var xe = {
  code: "code",
  em: "italic",
  i: "italic",
  s: "strikethrough",
  strong: "bold",
  sub: "subscript",
  sup: "superscript",
  u: "underline"
};

function pe(a) {
  var b = xe[a.nodeName.toLowerCase()];
  return void 0 === b ? {
    node: null
  } : {
    forChild: function forChild(c) {
      B(c) && !c.hasFormat(b) && c.toggleFormat(b);
      return c;
    },
    node: null
  };
}

function J() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return Ac(new me(a));
}

function B(a) {
  return a instanceof me;
}

var ye = /*#__PURE__*/function (_me) {
  _inherits(ye, _me);

  var _super3 = _createSuper(ye);

  function ye(a) {
    var _this3;

    _classCallCheck(this, ye);

    _this3 = _super3.call(this, "\t", a);
    _this3.__detail = 2;
    return _this3;
  }

  _createClass(ye, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(ye.prototype), "exportJSON", this).call(this)), {}, {
        type: "tab",
        version: 1
      });
    }
  }, {
    key: "setTextContent",
    value: function setTextContent() {
      r(126);
    }
  }, {
    key: "setDetail",
    value: function setDetail() {
      r(127);
    }
  }, {
    key: "setMode",
    value: function setMode() {
      r(128);
    }
  }, {
    key: "canInsertTextBefore",
    value: function canInsertTextBefore() {
      return !1;
    }
  }, {
    key: "canInsertTextAfter",
    value: function canInsertTextAfter() {
      return !1;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "tab";
    }
  }, {
    key: "clone",
    value: function clone(a) {
      var b = new ye(a.__key);
      b.__text = a.__text;
      b.__format = a.__format;
      b.__style = a.__style;
      return b;
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return null;
    }
  }, {
    key: "importJSON",
    value: function importJSON(a) {
      var b = ue();
      b.setFormat(a.format);
      b.setStyle(a.style);
      return b;
    }
  }]);

  return ye;
}(me);

function ue() {
  return Ac(new ye());
}

var ze = /*#__PURE__*/function () {
  function ze(a, b, c) {
    _classCallCheck(this, ze);

    this._selection = null;
    this.key = a;
    this.offset = b;
    this.type = c;
  }

  _createClass(ze, [{
    key: "is",
    value: function is(a) {
      return this.key === a.key && this.offset === a.offset && this.type === a.type;
    }
  }, {
    key: "isBefore",
    value: function isBefore(a) {
      var b = this.getNode(),
          c = a.getNode(),
          d = this.offset;
      a = a.offset;

      if (D(b)) {
        var e = b.getDescendantByIndex(d);
        b = null != e ? e : b;
      }

      D(c) && (e = c.getDescendantByIndex(a), c = null != e ? e : c);
      return b === c ? d < a : b.isBefore(c);
    }
  }, {
    key: "getNode",
    value: function getNode() {
      var a = I(this.key);
      null === a && r(20);
      return a;
    }
  }, {
    key: "set",
    value: function set(a, b, c) {
      var d = this._selection,
          e = this.key;
      this.key = a;
      this.offset = b;
      this.type = c;
      ec() || (dc() === e && H(a), null !== d && (d._cachedNodes = null, d.dirty = !0));
    }
  }]);

  return ze;
}();

function Ae(a, b) {
  var c = b.__key,
      d = a.offset,
      e = "element";
  if (B(b)) e = "text", b = b.getTextContentSize(), d > b && (d = b);else if (!D(b)) {
    var f = b.getNextSibling();
    if (B(f)) c = f.__key, d = 0, e = "text";else if (f = b.getParent()) c = f.__key, d = b.getIndexWithinParent() + 1;
  }
  a.set(c, d, e);
}

function ce(a, b) {
  if (D(b)) {
    var c = b.getLastDescendant();
    D(c) || B(c) ? Ae(a, c) : Ae(a, b);
  } else Ae(a, b);
}

function Be(a, b, c, d) {
  var e = a.getNode(),
      f = e.getChildAtIndex(a.offset),
      g = J(),
      h = K(e) ? de().append(g) : g;
  g.setFormat(c);
  g.setStyle(d);
  null === f ? e.append(h) : (f.insertBefore(h), "element" === b.type && b.key === a.key && b.offset !== a.offset && b.set(b.key, b.offset + 1, "element"));
  a.is(b) && b.set(g.__key, 0, "text");
  a.set(g.__key, 0, "text");
}

function Ce(a, b, c, d) {
  a.key = b;
  a.offset = c;
  a.type = d;
}

var De = /*#__PURE__*/function () {
  function De(a) {
    _classCallCheck(this, De);

    this.dirty = !1;
    this._nodes = a;
    this._cachedNodes = null;
  }

  _createClass(De, [{
    key: "is",
    value: function is(a) {
      if (!Ud(a)) return !1;
      var b = this._nodes,
          c = a._nodes;
      return b.size === c.size && Array.from(b).every(function (d) {
        return c.has(d);
      });
    }
  }, {
    key: "add",
    value: function add(a) {
      this.dirty = !0;

      this._nodes.add(a);

      this._cachedNodes = null;
    }
  }, {
    key: "delete",
    value: function _delete(a) {
      this.dirty = !0;

      this._nodes.delete(a);

      this._cachedNodes = null;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.dirty = !0;

      this._nodes.clear();

      this._cachedNodes = null;
    }
  }, {
    key: "has",
    value: function has(a) {
      return this._nodes.has(a);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new De(new Set(this._nodes));
    }
  }, {
    key: "extract",
    value: function extract() {
      return this.getNodes();
    }
  }, {
    key: "insertRawText",
    value: function insertRawText() {}
  }, {
    key: "insertText",
    value: function insertText() {}
  }, {
    key: "insertNodes",
    value: function insertNodes(a, b) {
      var c = this.getNodes(),
          d = c.length;
      var e = c[d - 1];
      if (B(e)) e = e.select();else {
        var f = e.getIndexWithinParent() + 1;
        e = e.getParentOrThrow().select(f, f);
      }
      e.insertNodes(a, b);

      for (a = 0; a < d; a++) {
        c[a].remove();
      }

      return !0;
    }
  }, {
    key: "getNodes",
    value: function getNodes() {
      var a = this._cachedNodes;
      if (null !== a) return a;
      var b = this._nodes;
      a = [];

      var _iterator5 = _createForOfIteratorHelper(b),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var c = _step5.value;
          b = I(c), null !== b && a.push(b);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      ec() || (this._cachedNodes = a);
      return a;
    }
  }, {
    key: "getTextContent",
    value: function getTextContent() {
      var a = this.getNodes(),
          b = "";

      for (var c = 0; c < a.length; c++) {
        b += a[c].getTextContent();
      }

      return b;
    }
  }]);

  return De;
}();

function C(a) {
  return a instanceof Ne;
}

function Oe(a) {
  var _Pe = Pe(a),
      _Pe2 = _slicedToArray(_Pe, 3),
      b = _Pe2[0],
      c = _Pe2[2];

  a = c.getChildren();
  var d = a.length;
  var e = a[0].getChildren().length;
  var f = Array(d);

  for (var g = 0; g < d; g++) {
    f[g] = Array(e);
  }

  for (e = 0; e < d; e++) {
    g = a[e].getChildren();
    var h = 0;

    for (var k = 0; k < g.length; k++) {
      for (; f[e][h];) {
        h++;
      }

      var m = g[k],
          n = m.__rowSpan || 1,
          p = m.__colSpan || 1;

      for (var l = 0; l < n; l++) {
        for (var q = 0; q < p; q++) {
          f[e + l][h + q] = m;
        }
      }

      if (b === m) return {
        colSpan: p,
        columnIndex: h,
        rowIndex: e,
        rowSpan: n
      };
      h += p;
    }
  }

  return null;
}

var Qe = /*#__PURE__*/function () {
  function Qe(a, b, c) {
    _classCallCheck(this, Qe);

    this.gridKey = a;
    this.anchor = b;
    this.focus = c;
    this.dirty = !1;
    this._cachedNodes = null;
    b._selection = this;
    c._selection = this;
  }

  _createClass(Qe, [{
    key: "is",
    value: function is(a) {
      return Re(a) ? this.gridKey === a.gridKey && this.anchor.is(a.anchor) && this.focus.is(a.focus) : !1;
    }
  }, {
    key: "set",
    value: function set(a, b, c) {
      this.dirty = !0;
      this.gridKey = a;
      this.anchor.key = b;
      this.focus.key = c;
      this._cachedNodes = null;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Qe(this.gridKey, this.anchor, this.focus);
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed() {
      return !1;
    }
  }, {
    key: "isBackward",
    value: function isBackward() {
      return this.focus.isBefore(this.anchor);
    }
  }, {
    key: "getCharacterOffsets",
    value: function getCharacterOffsets() {
      return Se(this);
    }
  }, {
    key: "extract",
    value: function extract() {
      return this.getNodes();
    }
  }, {
    key: "insertRawText",
    value: function insertRawText() {}
  }, {
    key: "insertText",
    value: function insertText() {}
  }, {
    key: "insertNodes",
    value: function insertNodes(a, b) {
      var c = this.focus.getNode();
      return Gb(c.select(0, c.getChildrenSize())).insertNodes(a, b);
    }
  }, {
    key: "getShape",
    value: function getShape() {
      var a = I(this.anchor.key);
      P(a) || r(103);
      a = Oe(a);
      if (null === a) throw Error("getCellRect: expected to find AnchorNode");
      var b = I(this.focus.key);
      P(b) || r(104);
      var c = Oe(b);
      if (null === c) throw Error("getCellRect: expected to find focusCellNode");
      b = Math.min(a.columnIndex, c.columnIndex);
      var d = Math.max(a.columnIndex, c.columnIndex),
          e = Math.min(a.rowIndex, c.rowIndex);
      a = Math.max(a.rowIndex, c.rowIndex);
      return {
        fromX: Math.min(b, d),
        fromY: Math.min(e, a),
        toX: Math.max(b, d),
        toY: Math.max(e, a)
      };
    }
  }, {
    key: "getNodes",
    value: function getNodes() {
      function a(x) {
        var y = x.cell,
            A = x.startColumn,
            Z = x.startRow;
        h = Math.min(h, A);
        k = Math.min(k, Z);
        m = Math.max(m, A + y.__colSpan - 1);
        n = Math.max(n, Z + y.__rowSpan - 1);
      }

      var b = this._cachedNodes;
      if (null !== b) return b;
      var c = this.anchor.getNode();
      b = this.focus.getNode();
      c = Fc(c, P);
      var d = Fc(b, P);
      P(c) || r(103);
      P(d) || r(104);
      b = c.getParent();
      Te(b) || r(105);
      b = b.getParent();
      Ue(b) || r(106);

      var _Ve = Ve(b, c, d),
          _Ve2 = _slicedToArray(_Ve, 3),
          e = _Ve2[0],
          f = _Ve2[1],
          g = _Ve2[2],
          h = Math.min(f.startColumn, g.startColumn),
          k = Math.min(f.startRow, g.startRow),
          m = Math.max(f.startColumn + f.cell.__colSpan - 1, g.startColumn + g.cell.__colSpan - 1),
          n = Math.max(f.startRow + f.cell.__rowSpan - 1, g.startRow + g.cell.__rowSpan - 1);

      c = h;
      d = k;

      for (var p = h, l = k; h < c || k < d || m > p || n > l;) {
        if (h < c) {
          var q = l - d;
          --c;

          for (var u = 0; u <= q; u++) {
            a(e[d + u][c]);
          }
        }

        if (k < d) for (q = p - c, --d, u = 0; u <= q; u++) {
          a(e[d][c + u]);
        }
        if (m > p) for (q = l - d, p += 1, u = 0; u <= q; u++) {
          a(e[d + u][p]);
        }
        if (n > l) for (q = p - c, l += 1, u = 0; u <= q; u++) {
          a(e[l][c + u]);
        }
      }

      b = [b];
      c = null;

      for (d = k; d <= n; d++) {
        for (p = h; p <= m; p++) {
          var _e$d$p, _b2;

          (_e$d$p = e[d][p], l = _e$d$p.cell, _e$d$p), q = l.getParent(), Te(q) || r(107), q !== c && b.push(q), (_b2 = b).push.apply(_b2, [l].concat(_toConsumableArray(Gc(l)))), c = q;
        }
      }

      ec() || (this._cachedNodes = b);
      return b;
    }
  }, {
    key: "getTextContent",
    value: function getTextContent() {
      var a = this.getNodes(),
          b = "";

      for (var c = 0; c < a.length; c++) {
        b += a[c].getTextContent();
      }

      return b;
    }
  }]);

  return Qe;
}();

function Re(a) {
  return a instanceof Qe;
}

var Ne = /*#__PURE__*/function () {
  function Ne(a, b, c, d) {
    _classCallCheck(this, Ne);

    this.anchor = a;
    this.focus = b;
    this.dirty = !1;
    this.format = c;
    this.style = d;
    this._cachedNodes = null;
    a._selection = this;
    b._selection = this;
  }

  _createClass(Ne, [{
    key: "is",
    value: function is(a) {
      return C(a) ? this.anchor.is(a.anchor) && this.focus.is(a.focus) && this.format === a.format && this.style === a.style : !1;
    }
  }, {
    key: "isBackward",
    value: function isBackward() {
      return this.focus.isBefore(this.anchor);
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed() {
      return this.anchor.is(this.focus);
    }
  }, {
    key: "getNodes",
    value: function getNodes() {
      var a = this._cachedNodes;
      if (null !== a) return a;
      a = this.anchor;
      var b = this.focus,
          c = a.isBefore(b),
          d = c ? a : b;
      c = c ? b : a;
      a = d.getNode();
      b = c.getNode();
      var e = d.offset;
      d = c.offset;
      D(a) && (c = a.getDescendantByIndex(e), a = null != c ? c : a);
      D(b) && (c = b.getDescendantByIndex(d), null !== c && c !== a && b.getChildAtIndex(d) === c && (c = c.getPreviousSibling()), b = null != c ? c : b);
      a = a.is(b) ? D(a) && 0 < a.getChildrenSize() ? [] : [a] : a.getNodesBetween(b);
      ec() || (this._cachedNodes = a);
      return a;
    }
  }, {
    key: "setTextNodeRange",
    value: function setTextNodeRange(a, b, c, d) {
      Ce(this.anchor, a.__key, b, "text");
      Ce(this.focus, c.__key, d, "text");
      this._cachedNodes = null;
      this.dirty = !0;
    }
  }, {
    key: "getTextContent",
    value: function getTextContent() {
      var a = this.getNodes();
      if (0 === a.length) return "";

      var b = a[0],
          c = a[a.length - 1],
          d = this.anchor,
          e = this.focus,
          f = d.isBefore(e),
          _Se = Se(this),
          _Se2 = _slicedToArray(_Se, 2),
          g = _Se2[0],
          h = _Se2[1],
          k = "",
          m = !0;

      for (var n = 0; n < a.length; n++) {
        var p = a[n];
        if (D(p) && !p.isInline()) m || (k += "\n"), m = p.isEmpty() ? !1 : !0;else if (m = !1, B(p)) {
          var l = p.getTextContent();
          if (p === b) {
            if (p === c) {
              if ("element" !== d.type || "element" !== e.type || e.offset === d.offset) l = g < h ? l.slice(g, h) : l.slice(h, g);
            } else l = f ? l.slice(g) : l.slice(h);
          } else p === c && (l = f ? l.slice(0, h) : l.slice(0, g));
          k += l;
        } else !z(p) && !Yb(p) || p === c && this.isCollapsed() || (k += p.getTextContent());
      }

      return k;
    }
  }, {
    key: "applyDOMRange",
    value: function applyDOMRange(a) {
      var b = F(),
          c = b.getEditorState()._selection;

      a = We(a.startContainer, a.startOffset, a.endContainer, a.endOffset, b, c);

      if (null !== a) {
        var _a9 = a,
            _a10 = _slicedToArray(_a9, 2),
            d = _a10[0],
            e = _a10[1];

        Ce(this.anchor, d.key, d.offset, d.type);
        Ce(this.focus, e.key, e.offset, e.type);
        this._cachedNodes = null;
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      var a = this.anchor,
          b = this.focus;
      return new Ne(new ze(a.key, a.offset, a.type), new ze(b.key, b.offset, b.type), this.format, this.style);
    }
  }, {
    key: "toggleFormat",
    value: function toggleFormat(a) {
      this.format = Wb(this.format, a, null);
      this.dirty = !0;
    }
  }, {
    key: "setStyle",
    value: function setStyle(a) {
      this.style = a;
      this.dirty = !0;
    }
  }, {
    key: "hasFormat",
    value: function hasFormat(a) {
      return 0 !== (this.format & fb[a]);
    }
  }, {
    key: "insertRawText",
    value: function insertRawText(a) {
      a = a.split(/(\r?\n|\t)/);
      var b = [],
          c = a.length;

      for (var d = 0; d < c; d++) {
        var e = a[d];
        "\n" === e || "\r\n" === e ? b.push(ge()) : "\t" === e ? b.push(ue()) : b.push(J(e));
      }

      this.insertNodes(b);
    }
  }, {
    key: "insertText",
    value: function insertText(a) {
      var b = this.anchor,
          c = this.focus,
          d = this.isCollapsed() || b.isBefore(c),
          e = this.format,
          f = this.style;
      d && "element" === b.type ? Be(b, c, e, f) : d || "element" !== c.type || Be(c, b, e, f);
      var g = this.getNodes(),
          h = g.length,
          k = d ? c : b;
      c = (d ? b : c).offset;
      var m = k.offset;
      b = g[0];
      B(b) || r(26);
      d = b.getTextContent().length;
      var n = b.getParentOrThrow(),
          p = g[h - 1];

      if (this.isCollapsed() && c === d && (b.isSegmented() || b.isToken() || !b.canInsertTextAfter() || !n.canInsertTextAfter() && null === b.getNextSibling())) {
        var l = b.getNextSibling();
        B(l) && l.canInsertTextBefore() && !Ob(l) || (l = J(), l.setFormat(e), n.canInsertTextAfter() ? b.insertAfter(l) : n.insertAfter(l));
        l.select(0, 0);
        b = l;

        if ("" !== a) {
          this.insertText(a);
          return;
        }
      } else if (this.isCollapsed() && 0 === c && (b.isSegmented() || b.isToken() || !b.canInsertTextBefore() || !n.canInsertTextBefore() && null === b.getPreviousSibling())) {
        l = b.getPreviousSibling();
        if (!B(l) || Ob(l)) l = J(), l.setFormat(e), n.canInsertTextBefore() ? b.insertBefore(l) : n.insertBefore(l);
        l.select();
        b = l;

        if ("" !== a) {
          this.insertText(a);
          return;
        }
      } else if (b.isSegmented() && c !== d) n = J(b.getTextContent()), n.setFormat(e), b.replace(n), b = n;else if (!(this.isCollapsed() || "" === a || (l = p.getParent(), n.canInsertTextBefore() && n.canInsertTextAfter() && (!D(l) || l.canInsertTextBefore() && l.canInsertTextAfter())))) {
        this.insertText("");
        Xe(this.anchor, this.focus, null);
        this.insertText(a);
        return;
      }

      if (1 === h) {
        if (b.isToken()) a = J(a), a.select(), b.replace(a);else {
          g = b.getFormat();
          h = b.getStyle();
          if (c === m && (g !== e || h !== f)) if ("" === b.getTextContent()) b.setFormat(e), b.setStyle(f);else {
            var _b$splitText, _b$splitText2;

            g = J(a);
            g.setFormat(e);
            g.setStyle(f);
            g.select();
            0 === c ? b.insertBefore(g, !1) : ((_b$splitText = b.splitText(c), _b$splitText2 = _slicedToArray(_b$splitText, 1), h = _b$splitText2[0], _b$splitText), h.insertAfter(g, !1));
            g.isComposing() && "text" === this.anchor.type && (this.anchor.offset -= a.length);
            return;
          }
          b = b.spliceText(c, m - c, a, !0);
          "" === b.getTextContent() ? b.remove() : "text" === this.anchor.type && (b.isComposing() ? this.anchor.offset -= a.length : (this.format = g, this.style = h));
        }
      } else {
        e = new Set([].concat(_toConsumableArray(b.getParentKeys()), _toConsumableArray(p.getParentKeys())));
        l = D(b) ? b : b.getParentOrThrow();
        f = D(p) ? p : p.getParentOrThrow();
        n = p;

        if (!l.is(f) && f.isInline()) {
          do {
            n = f, f = f.getParentOrThrow();
          } while (f.isInline());
        }

        if ("text" === k.type && (0 !== m || "" === p.getTextContent()) || "element" === k.type && p.getIndexWithinParent() < m) {
          if (B(p) && !p.isToken() && m !== p.getTextContentSize()) {
            if (p.isSegmented()) {
              var q = J(p.getTextContent());
              p.replace(q);
              p = q;
            }

            K(k.getNode()) || (p = p.spliceText(0, m, ""));
            e.add(p.__key);
          } else k = p.getParentOrThrow(), k.canBeEmpty() || 1 !== k.getChildrenSize() ? p.remove() : k.remove();
        } else e.add(p.__key);
        k = f.getChildren();
        m = new Set(g);
        p = l.is(f);
        l = l.isInline() && null === b.getNextSibling() ? l : b;

        for (q = k.length - 1; 0 <= q; q--) {
          var u = k[q];
          if (u.is(b) || D(u) && u.isParentOf(b)) break;
          u.isAttached() && (!m.has(u) || u.is(n) ? p || l.insertAfter(u, !1) : u.remove());
        }

        if (!p) for (k = f, m = null; null !== k;) {
          f = k.getChildren();
          p = f.length;
          if (0 === p || f[p - 1].is(m)) e.delete(k.__key), m = k;
          k = k.getParent();
        }
        b.isToken() ? c === d ? b.select() : (a = J(a), a.select(), b.replace(a)) : (b = b.spliceText(c, d - c, a, !0), "" === b.getTextContent() ? b.remove() : b.isComposing() && "text" === this.anchor.type && (this.anchor.offset -= a.length));

        for (a = 1; a < h; a++) {
          b = g[a], e.has(b.__key) || b.remove();
        }
      }
    }
  }, {
    key: "removeText",
    value: function removeText() {
      this.insertText("");
    }
  }, {
    key: "formatText",
    value: function formatText(a) {
      if (this.isCollapsed()) this.toggleFormat(a), H(null);else {
        var b = this.getNodes(),
            c = [];

        var _iterator6 = _createForOfIteratorHelper(b),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var d = _step6.value;
            B(d) && c.push(d);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        var e = c.length;
        if (0 === e) this.toggleFormat(a), H(null);else {
          d = this.anchor;
          var f = this.focus,
              g = this.isBackward();
          b = g ? f : d;
          d = g ? d : f;
          var h = 0,
              k = c[0];
          f = "element" === b.type ? 0 : b.offset;
          "text" === b.type && f === k.getTextContentSize() && (h = 1, k = c[1], f = 0);

          if (null != k) {
            g = k.getFormatFlags(a, null);
            var m = e - 1,
                n = c[m];
            e = "text" === d.type ? d.offset : n.getTextContentSize();
            if (k.is(n)) f !== e && (0 === f && e === k.getTextContentSize() ? k.setFormat(g) : (a = k.splitText(f, e), a = 0 === f ? a[0] : a[1], a.setFormat(g), "text" === b.type && b.set(a.__key, 0, "text"), "text" === d.type && d.set(a.__key, e - f, "text")), this.format = g);else {
              var _k$splitText, _k$splitText2, _n$splitText, _n$splitText2;

              0 !== f && ((_k$splitText = k.splitText(f), _k$splitText2 = _slicedToArray(_k$splitText, 2), k = _k$splitText2[1], _k$splitText), f = 0);
              k.setFormat(g);
              var p = n.getFormatFlags(a, g);
              0 < e && (e !== n.getTextContentSize() && (_n$splitText = n.splitText(e), _n$splitText2 = _slicedToArray(_n$splitText, 1), n = _n$splitText2[0], _n$splitText), n.setFormat(p));

              for (h += 1; h < m; h++) {
                var l = c[h];

                if (!l.isToken()) {
                  var q = l.getFormatFlags(a, p);
                  l.setFormat(q);
                }
              }

              "text" === b.type && b.set(k.__key, f, "text");
              "text" === d.type && d.set(n.__key, e, "text");
              this.format = g | p;
            }
          }
        }
      }
    }
  }, {
    key: "insertNodes",
    value: function insertNodes(a, b) {
      var _e2;

      if (!this.isCollapsed()) {
        var c = this.isBackward() ? this.anchor : this.focus,
            d = c.getNode().getNextSibling();
        d = d ? d.getKey() : null;
        c = (c = c.getNode().getPreviousSibling()) ? c.getKey() : null;
        this.removeText();

        if (this.isCollapsed() && "element" === this.focus.type) {
          if (this.focus.key === d && 0 === this.focus.offset) {
            var e = J();
            this.focus.getNode().insertBefore(e);
          } else this.focus.key === c && this.focus.offset === this.focus.getNode().getChildrenSize() && (e = J(), this.focus.getNode().insertAfter(e));

          e && (this.focus.set(e.__key, 0, "text"), this.anchor.set(e.__key, 0, "text"));
        }
      }

      e = this.anchor;
      c = e.offset;
      var f = e.getNode();
      d = f;
      "element" === e.type && (e = e.getNode(), d = e.getChildAtIndex(c - 1), d = null === d ? e : d);
      e = [];
      var g = f.getNextSiblings(),
          h = yc(f) ? null : f.getTopLevelElementOrThrow();
      if (B(f)) if (d = f.getTextContent().length, 0 === c && 0 !== d) d = f.getPreviousSibling(), d = null !== d ? d : f.getParentOrThrow(), e.push(f);else if (c === d) d = f;else {
        if (f.isToken()) return !1;

        var _f$splitText = f.splitText(c);

        var _f$splitText2 = _slicedToArray(_f$splitText, 2);

        d = _f$splitText2[0];
        f = _f$splitText2[1];
        e.push(f);
      }
      f = d;

      (_e2 = e).push.apply(_e2, _toConsumableArray(g));

      g = a[0];
      var k = !1,
          m = null;

      for (var q = 0; q < a.length; q++) {
        var _d$splitText, _d$splitText2, _Ec, _Ec2;

        var n = a[q];
        if (yc(d) || z(d) || !D(n) || n.isInline()) k && !D(n) && !z(n) && yc(d.getParent()) && r(28);else {
          if (n.is(g)) {
            if (D(d) && d.isEmpty() && d.canReplaceWith(n)) {
              d.replace(n);
              d = n;
              k = !0;
              continue;
            }

            k = n.getFirstDescendant();

            if (Xb(k)) {
              for (var p = k.getParentOrThrow(); p.isInline();) {
                p = p.getParentOrThrow();
              }

              m = p.getChildren();
              k = m.length;

              if (D(d)) {
                var l = d.getFirstChild();

                for (var u = 0; u < k; u++) {
                  var x = m[u];
                  null === l ? d.append(x) : l.insertAfter(x);
                  l = x;
                }
              } else {
                for (l = k - 1; 0 <= l; l--) {
                  d.insertAfter(m[l]);
                }

                d = d.getParentOrThrow();
              }

              m = m[k - 1];
              p.remove();
              k = !0;
              if (p.is(n)) continue;
            }
          }

          B(d) && (null === h && r(27), d = h);
        }
        k = !1;
        if (D(d) && !d.isInline()) {
          if (m = n, z(n) && !n.isInline()) d = 1 === a.length && d.canBeEmpty() && d.isEmpty() ? d.insertBefore(n, !1) : d.insertAfter(n, !1);else if (D(n)) {
            if (n.canBeEmpty() || !n.isEmpty()) K(d) ? (p = d.getChildAtIndex(c), null !== p ? p.insertBefore(n) : d.append(n), d = n) : n.isInline() ? (d.append(n), d = n) : d = d.insertAfter(n, !1);
          } else p = d.getFirstChild(), null !== p ? p.insertBefore(n) : d.append(n), d = n;
        } else !D(n) || D(n) && n.isInline() || z(d) && !d.isInline() ? (m = n, C(this) && z(n) && (D(d) || B(d)) && !n.isInline() ? (B(d) ? (p = d.getParentOrThrow(), (_d$splitText = d.splitText(c), _d$splitText2 = _slicedToArray(_d$splitText, 1), d = _d$splitText2[0], _d$splitText), d = d.getIndexWithinParent() + 1) : (p = d, d = c), (_Ec = Ec(p, d), _Ec2 = _slicedToArray(_Ec, 2), d = _Ec2[1], _Ec), d = d.insertBefore(n)) : d = d.insertAfter(n, !1)) : (n = d.getParentOrThrow(), Yb(d) && d.remove(), d = n, q--);
      }

      b && (B(f) ? f.select() : (a = d.getPreviousSibling(), B(a) ? a.select() : (a = d.getIndexWithinParent(), d.getParentOrThrow().select(a, a))));

      if (D(d)) {
        if (a = B(m) ? m : D(m) && m.isInline() ? m.getLastDescendant() : d.getLastDescendant(), b || (null === a ? d.select() : B(a) ? "" === a.getTextContent() ? a.selectPrevious() : a.select() : a.selectNext()), 0 !== e.length) for (b = d, a = e.length - 1; 0 <= a; a--) {
          c = e[a], h = c.getParentOrThrow(), !D(d) || Ye(c) || z(c) && (!c.isInline() || c.isIsolated()) ? D(d) || Ye(c) ? D(c) && !c.canInsertAfter(d) ? (f = h.constructor.clone(h), D(f) || r(29), f.append(c), d.insertAfter(f)) : d.insertAfter(c) : (d.insertBefore(c), d = c) : (b === d ? d.append(c) : d.insertBefore(c), d = c), h.isEmpty() && !h.canBeEmpty() && h.remove();
        }
      } else b || (B(d) ? d.select() : (b = d.getParentOrThrow(), a = d.getIndexWithinParent() + 1, b.select(a, a)));

      return !0;
    }
  }, {
    key: "insertParagraph",
    value: function insertParagraph() {
      this.isCollapsed() || this.removeText();
      var a = this.anchor,
          b = a.offset,
          c = [];

      if ("text" === a.type) {
        var _d$splitText3, _d$splitText4;

        var d = a.getNode();
        var e = d.getNextSiblings().reverse();
        var f = d.getParentOrThrow();
        var g = f.isInline(),
            h = g ? f.getTextContentSize() : d.getTextContentSize();
        0 === b ? e.push(d) : (g && (c = f.getNextSiblings()), b === h || g && b === d.getTextContentSize() || ((_d$splitText3 = d.splitText(b), _d$splitText4 = _slicedToArray(_d$splitText3, 2), d = _d$splitText4[1], _d$splitText3), e.push(d)));
      } else {
        f = a.getNode();

        if (yc(f)) {
          e = de();
          c = f.getChildAtIndex(b);
          e.select();
          null !== c ? c.insertBefore(e, !1) : f.append(e);
          return;
        }

        e = f.getChildren().slice(b).reverse();
      }

      d = e.length;

      if (0 === b && 0 < d && f.isInline()) {
        if (c = f.getParentOrThrow(), e = c.insertNewAfter(this, !1), D(e)) for (c = c.getChildren(), f = 0; f < c.length; f++) {
          e.append(c[f]);
        }
      } else if (g = f.insertNewAfter(this, !1), null === g) this.insertLineBreak();else if (D(g)) if (h = f.getFirstChild(), 0 === b && (f.is(a.getNode()) || h && h.is(a.getNode())) && 0 < d) f.insertBefore(g);else {
        f = null;
        b = c.length;
        a = g.getParentOrThrow();
        if (0 < b) for (h = 0; h < b; h++) {
          a.append(c[h]);
        }
        if (0 !== d) for (c = 0; c < d; c++) {
          b = e[c], null === f ? g.append(b) : f.insertBefore(b), f = b;
        }
        g.canBeEmpty() || 0 !== g.getChildrenSize() ? g.selectStart() : (g.selectPrevious(), g.remove());
      }
    }
  }, {
    key: "insertLineBreak",
    value: function insertLineBreak(a) {
      var b = ge();
      var c = this.anchor;
      "element" === c.type && (c = c.getNode(), K(c) && this.insertParagraph());
      a ? this.insertNodes([b], !0) : this.insertNodes([b]) && b.selectNext(0, 0);
    }
  }, {
    key: "getCharacterOffsets",
    value: function getCharacterOffsets() {
      return Se(this);
    }
  }, {
    key: "extract",
    value: function extract() {
      var _f$splitText3, _f$splitText4, _g$splitText, _g$splitText2;

      var a = this.getNodes(),
          b = a.length,
          c = b - 1,
          d = this.anchor;
      var e = this.focus;
      var f = a[0];

      var g = a[c],
          _Se3 = Se(this),
          _Se4 = _slicedToArray(_Se3, 2),
          h = _Se4[0],
          k = _Se4[1];

      if (0 === b) return [];
      if (1 === b) return B(f) && !this.isCollapsed() ? (a = h > k ? k : h, c = f.splitText(a, h > k ? h : k), a = 0 === a ? c[0] : c[1], null != a ? [a] : []) : [f];
      b = d.isBefore(e);
      B(f) && (d = b ? h : k, d === f.getTextContentSize() ? a.shift() : 0 !== d && ((_f$splitText3 = f.splitText(d), _f$splitText4 = _slicedToArray(_f$splitText3, 2), f = _f$splitText4[1], _f$splitText3), a[0] = f));
      B(g) && (f = g.getTextContent().length, b = b ? k : h, 0 === b ? a.pop() : b !== f && ((_g$splitText = g.splitText(b), _g$splitText2 = _slicedToArray(_g$splitText, 1), g = _g$splitText2[0], _g$splitText), a[c] = g));
      return a;
    }
  }, {
    key: "modify",
    value: function modify(a, b, c) {
      var d = this.focus,
          e = this.anchor,
          f = "move" === a,
          g = tc(d, b);
      if (z(g) && !g.isIsolated()) f && g.isKeyboardSelectable() ? (b = Ze(), b.add(g.__key), yb(b)) : (a = b ? g.getPreviousSibling() : g.getNextSibling(), B(a) ? (g = a.__key, b = b ? a.getTextContent().length : 0, d.set(g, b, "text"), f && e.set(g, b, "text")) : (c = g.getParentOrThrow(), D(a) ? (c = a.__key, g = b ? a.getChildrenSize() : 0) : (g = g.getIndexWithinParent(), c = c.__key, b || g++), d.set(c, g, "element"), f && e.set(c, g, "element")));else if (e = F(), d = vb(e._window)) {
        var h = e._blockCursorElement,
            k = e._rootElement;
        null === k || null === h || !D(g) || g.isInline() || g.canBeEmpty() || Dc(h, e, k);
        d.modify(a, b ? "backward" : "forward", c);

        if (0 < d.rangeCount && (g = d.getRangeAt(0), e = this.anchor.getNode(), e = K(e) ? e : xc(e), this.applyDOMRange(g), this.dirty = !0, !f)) {
          f = this.getNodes();
          a = [];
          c = !1;

          for (h = 0; h < f.length; h++) {
            k = f[h], wc(k, e) ? a.push(k) : c = !0;
          }

          c && 0 < a.length && (b ? (b = a[0], D(b) ? b.selectStart() : b.getParentOrThrow().selectStart()) : (b = a[a.length - 1], D(b) ? b.selectEnd() : b.getParentOrThrow().selectEnd()));
          if (d.anchorNode !== g.startContainer || d.anchorOffset !== g.startOffset) b = this.focus, f = this.anchor, d = f.key, g = f.offset, e = f.type, Ce(f, b.key, b.offset, b.type), Ce(b, d, g, e), this._cachedNodes = null;
        }
      }
    }
  }, {
    key: "deleteCharacter",
    value: function deleteCharacter(a) {
      var b = this.isCollapsed();

      if (this.isCollapsed()) {
        var c = this.anchor,
            d = this.focus,
            e = c.getNode();

        if (!a && ("element" === c.type && D(e) && c.offset === e.getChildrenSize() || "text" === c.type && c.offset === e.getTextContentSize())) {
          var f = e.getParent();
          f = e.getNextSibling() || (null === f ? null : f.getNextSibling());
          if (D(f) && f.isShadowRoot()) return;
        }

        f = tc(d, a);

        if (z(f) && !f.isIsolated()) {
          f.isKeyboardSelectable() && D(e) && 0 === e.getChildrenSize() ? (e.remove(), a = Ze(), a.add(f.__key), yb(a)) : (f.remove(), F().dispatchCommand(aa, void 0));
          return;
        }

        if (!a && D(f) && D(e) && e.isEmpty()) {
          e.remove();
          f.selectStart();
          return;
        }

        this.modify("extend", a, "character");

        if (!this.isCollapsed()) {
          f = "text" === d.type ? d.getNode() : null;
          e = "text" === c.type ? c.getNode() : null;

          if (null !== f && f.isSegmented()) {
            if (c = d.offset, d = f.getTextContentSize(), f.is(e) || a && c !== d || !a && 0 !== c) {
              $e(f, a, c);
              return;
            }
          } else if (null !== e && e.isSegmented() && (c = c.offset, d = e.getTextContentSize(), e.is(f) || a && 0 !== c || !a && c !== d)) {
            $e(e, a, c);
            return;
          }

          e = this.anchor;
          f = this.focus;
          c = e.getNode();
          d = f.getNode();

          if (c === d && "text" === e.type && "text" === f.type) {
            var g = e.offset,
                h = f.offset;
            var k = g < h;
            d = k ? g : h;
            h = k ? h : g;
            g = h - 1;
            d !== g && (c = c.getTextContent().slice(d, h), kc(c) || (a ? f.offset = g : e.offset = g));
          }
        } else if (a && 0 === c.offset && ("element" === c.type ? c.getNode() : c.getNode().getParentOrThrow()).collapseAtStart(this)) return;
      }

      this.removeText();
      a && !b && this.isCollapsed() && "element" === this.anchor.type && 0 === this.anchor.offset && (a = this.anchor.getNode(), a.isEmpty() && K(a.getParent()) && 0 === a.getIndexWithinParent() && a.collapseAtStart(this));
    }
  }, {
    key: "deleteLine",
    value: function deleteLine(a) {
      this.isCollapsed() && ("text" === this.anchor.type && this.modify("extend", a, "lineboundary"), 0 === (a ? this.focus : this.anchor).offset && this.modify("extend", a, "character"));
      this.removeText();
    }
  }, {
    key: "deleteWord",
    value: function deleteWord(a) {
      this.isCollapsed() && this.modify("extend", a, "word");
      this.removeText();
    }
  }]);

  return Ne;
}();

function Ud(a) {
  return a instanceof De;
}

function af(a) {
  var b = a.offset;
  if ("text" === a.type) return b;
  a = a.getNode();
  return b === a.getChildrenSize() ? a.getTextContent().length : 0;
}

function Se(a) {
  var b = a.anchor;
  a = a.focus;
  return "element" === b.type && "element" === a.type && b.key === a.key && b.offset === a.offset ? [0, 0] : [af(b), af(a)];
}

function $e(a, b, c) {
  var d = a.getTextContent().split(/(?=\s)/g),
      e = d.length,
      f = 0,
      g = 0;

  for (var h = 0; h < e; h++) {
    var k = d[h],
        m = h === e - 1;
    g = f;
    f += k.length;

    if (b && f === c || f > c || m) {
      d.splice(h, 1);
      m && (g = void 0);
      break;
    }
  }

  b = d.join("").trim();
  "" === b ? a.remove() : (a.setTextContent(b), a.select(g, g));
}

function bf(a, b, c, d) {
  var e = b;

  if (1 === a.nodeType) {
    var h = !1;
    var f = a.childNodes,
        g = f.length;
    e === g && (h = !0, e = g - 1);
    var k = f[e];
    g = !1;
    k === d._blockCursorElement ? (k = f[e + 1], g = !0) : null !== d._blockCursorElement && e--;
    d = jc(k);
    if (B(d)) e = h ? d.getTextContentSize() : 0;else {
      f = jc(a);
      if (null === f) return null;

      if (D(f)) {
        a = f.getChildAtIndex(e);
        if (b = D(a)) b = a.getParent(), b = null === c || null === b || !b.canBeEmpty() || b !== c.getNode();
        b && (c = h ? a.getLastDescendant() : a.getFirstDescendant(), null === c ? (f = a, e = 0) : (a = c, f = D(a) ? a : a.getParentOrThrow()));
        B(a) ? (d = a, f = null, e = h ? a.getTextContentSize() : 0) : a !== f && h && !g && e++;
      } else e = f.getIndexWithinParent(), e = 0 === b && z(f) && jc(a) === f ? e : e + 1, f = f.getParentOrThrow();

      if (D(f)) return new ze(f.__key, e, "element");
    }
  } else d = jc(a);

  return B(d) ? new ze(d.__key, e, "text") : null;
}

function cf(a, b, c) {
  var d = a.offset,
      e = a.getNode();
  0 === d ? (d = e.getPreviousSibling(), e = e.getParent(), b) ? (c || !b) && null === d && D(e) && e.isInline() && (b = e.getPreviousSibling(), B(b) && (a.key = b.__key, a.offset = b.getTextContent().length)) : D(d) && !c && d.isInline() ? (a.key = d.__key, a.offset = d.getChildrenSize(), a.type = "element") : B(d) && (a.key = d.__key, a.offset = d.getTextContent().length) : d === e.getTextContent().length && (d = e.getNextSibling(), e = e.getParent(), b && D(d) && d.isInline() ? (a.key = d.__key, a.offset = 0, a.type = "element") : (c || b) && null === d && D(e) && e.isInline() && !e.canInsertTextAfter() && (b = e.getNextSibling(), B(b) && (a.key = b.__key, a.offset = 0)));
}

function Xe(a, b, c) {
  if ("text" === a.type && "text" === b.type) {
    var d = a.isBefore(b);
    var e = a.is(b);
    cf(a, d, e);
    cf(b, !d, e);
    e && (b.key = a.key, b.offset = a.offset, b.type = a.type);
    d = F();
    d.isComposing() && d._compositionKey !== a.key && C(c) && (d = c.anchor, c = c.focus, Ce(a, d.key, d.offset, d.type), Ce(b, c.key, c.offset, c.type));
  }
}

function We(a, b, c, d, e, f) {
  if (null === a || null === c || !Lb(e, a, c)) return null;
  b = bf(a, b, C(f) ? f.anchor : null, e);
  if (null === b) return null;
  d = bf(c, d, C(f) ? f.focus : null, e);
  if (null === d || "element" === b.type && "element" === d.type && (a = jc(a), c = jc(c), z(a) && z(c))) return null;
  Xe(b, d, f);
  return [b, d];
}

function Ye(a) {
  return D(a) && !a.isInline();
}

function re(a, b, c, d, e, f) {
  var g = ac();
  a = new Ne(new ze(a, b, e), new ze(c, d, f), 0, "");
  a.dirty = !0;
  return g._selection = a;
}

function Ze() {
  return new De(new Set());
}

function df(a) {
  var b = a.getEditorState()._selection,
      c = vb(a._window);

  return Ud(b) || Re(b) ? b.clone() : Qd(b, c, a);
}

function Qd(a, b, c) {
  var d = c._window;
  if (null === d) return null;
  var e = d.event,
      f = e ? e.type : void 0;
  d = "selectionchange" === f;
  e = !ob && (d || "beforeinput" === f || "compositionstart" === f || "compositionend" === f || "click" === f && e && 3 === e.detail || "drop" === f || void 0 === f);
  var g;

  if (!C(a) || e) {
    if (null === b) return null;
    e = b.anchorNode;
    f = b.focusNode;
    g = b.anchorOffset;
    b = b.focusOffset;
    if (d && C(a) && !Lb(c, e, f)) return a.clone();
  } else return a.clone();

  c = We(e, g, f, b, c, a);
  if (null === c) return null;

  var _c = c,
      _c2 = _slicedToArray(_c, 2),
      h = _c2[0],
      k = _c2[1];

  return new Ne(h, k, C(a) ? a.format : 0, C(a) ? a.style : "");
}

function v() {
  return ac()._selection;
}

function oc() {
  return F()._editorState._selection;
}

function ae(a, b, c) {
  var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var e = a.anchor,
      f = a.focus,
      g = e.getNode(),
      h = f.getNode();

  if (b.is(g) || b.is(h)) {
    g = b.__key;

    if (a.isCollapsed()) {
      if (b = e.offset, c <= b && 0 < d || c < b && 0 > d) c = Math.max(0, b + d), e.set(g, c, "element"), f.set(g, c, "element"), ef(a);
    } else {
      var m = a.isBackward();
      h = m ? f : e;
      var k = h.getNode();
      e = m ? e : f;
      f = e.getNode();
      b.is(k) && (k = h.offset, (c <= k && 0 < d || c < k && 0 > d) && h.set(g, Math.max(0, k + d), "element"));
      b.is(f) && (b = e.offset, (c <= b && 0 < d || c < b && 0 > d) && e.set(g, Math.max(0, b + d), "element"));
    }

    ef(a);
  }
}

function ef(a) {
  var b = a.anchor,
      c = b.offset;
  var d = a.focus;
  var e = d.offset,
      f = b.getNode(),
      g = d.getNode();
  if (a.isCollapsed()) D(f) && (g = f.getChildrenSize(), g = (e = c >= g) ? f.getChildAtIndex(g - 1) : f.getChildAtIndex(c), B(g) && (c = 0, e && (c = g.getTextContentSize()), b.set(g.__key, c, "text"), d.set(g.__key, c, "text")));else {
    if (D(f)) {
      var h = f.getChildrenSize();
      c = (a = c >= h) ? f.getChildAtIndex(h - 1) : f.getChildAtIndex(c);
      B(c) && (f = 0, a && (f = c.getTextContentSize()), b.set(c.__key, f, "text"));
    }

    D(g) && (c = g.getChildrenSize(), e = (b = e >= c) ? g.getChildAtIndex(c - 1) : g.getChildAtIndex(e), B(e) && (g = 0, b && (g = e.getTextContentSize()), d.set(e.__key, g, "text")));
  }
}

function ff(a, b) {
  b = b.getEditorState()._selection;
  a = a._selection;

  if (C(a)) {
    var c = a.anchor;
    var d = a.focus,
        e;
    "text" === c.type && (e = c.getNode(), e.selectionTransform(b, a));
    "text" === d.type && (c = d.getNode(), e !== c && c.selectionTransform(b, a));
  }
}

function $d(a, b, c, d, e) {
  var f = null,
      g = 0,
      h = null;
  null !== d ? (f = d.__key, B(d) ? (g = d.getTextContentSize(), h = "text") : D(d) && (g = d.getChildrenSize(), h = "element")) : null !== e && (f = e.__key, B(e) ? h = "text" : D(e) && (h = "element"));
  null !== f && null !== h ? a.set(f, g, h) : (g = b.getIndexWithinParent(), -1 === g && (g = c.getChildrenSize()), a.set(c.__key, g, "element"));
}

function se(a, b, c, d, e) {
  "text" === a.type ? (a.key = c, b || (a.offset += e)) : a.offset > d.getIndexWithinParent() && --a.offset;
}

function Ve(a, b, c) {
  var d = [],
      e = null,
      f = null;
  a = a.getChildren();

  for (var n = 0; n < a.length; n++) {
    var g = a[n];
    Te(g) || r(108);
    var h = g.getChildren();
    g = 0;

    var _iterator7 = _createForOfIteratorHelper(h),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var p = _step7.value;

        for (P(p) || r(109); void 0 !== d[n] && void 0 !== d[n][g];) {
          g++;
        }

        h = n;
        var k = g,
            m = p;
        var l = {
          cell: m,
          startColumn: k,
          startRow: h
        },
            q = m.__rowSpan,
            u = m.__colSpan;

        for (var x = 0; x < q; x++) {
          void 0 === d[h + x] && (d[h + x] = []);

          for (var y = 0; y < u; y++) {
            d[h + x][k + y] = l;
          }
        }

        b.is(m) && (e = l);
        c.is(m) && (f = l);
        g += p.__colSpan;
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }

  null === e && r(110);
  null === f && r(111);
  return [d, e, f];
}

function Pe(a) {
  a instanceof gf || (a instanceof be ? (a = Fc(a, P), P(a) || r(114)) : (a = Fc(a.getNode(), P), P(a) || r(114)));
  var b = a.getParent();
  Te(b) || r(115);
  var c = b.getParent();
  Ue(c) || r(116);
  return [a, b, c];
}

var S = null,
    T = null,
    V = !1,
    hf = !1,
    $b = 0,
    jf = {
  characterData: !0,
  childList: !0,
  subtree: !0
};

function ec() {
  return V || null !== S && S._readOnly;
}

function G() {
  V && r(13);
}

function ac() {
  null === S && r(15);
  return S;
}

function F() {
  null === T && r(16);
  return T;
}

function kf(a, b, c) {
  var d = b.__type;

  var e = a._nodes.get(d);

  void 0 === e && r(30, d);
  a = c.get(d);
  void 0 === a && (a = Array.from(e.transforms), c.set(d, a));
  c = a.length;

  for (d = 0; d < c && (a[d](b), b.isAttached()); d++) {
    ;
  }
}

function lf(a, b) {
  b = b._dirtyLeaves;
  a = a._nodeMap;

  var _iterator8 = _createForOfIteratorHelper(b),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var c = _step8.value;
      b = a.get(c), B(b) && b.isAttached() && b.isSimpleText() && !b.isUnmergeable() && Fb(b);
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
}

function mf(a, b) {
  var c = b._dirtyLeaves,
      d = b._dirtyElements;
  a = a._nodeMap;
  var e = dc(),
      f = new Map();
  var g = c;
  var h = g.size;

  for (var k = d, m = k.size; 0 < h || 0 < m;) {
    if (0 < h) {
      b._dirtyLeaves = new Set();

      var _iterator9 = _createForOfIteratorHelper(g),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var n = _step9.value;
          g = a.get(n), B(g) && g.isAttached() && g.isSimpleText() && !g.isUnmergeable() && Fb(g), void 0 !== g && void 0 !== g && g.__key !== e && g.isAttached() && kf(b, g, f), c.add(n);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      g = b._dirtyLeaves;
      h = g.size;

      if (0 < h) {
        $b++;
        continue;
      }
    }

    b._dirtyLeaves = new Set();
    b._dirtyElements = new Map();

    var _iterator10 = _createForOfIteratorHelper(k),
        _step10;

    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var _n = _step10.value;
        if (k = _n[0], m = _n[1], "root" === k || m) g = a.get(k), void 0 !== g && void 0 !== g && g.__key !== e && g.isAttached() && kf(b, g, f), d.set(k, m);
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }

    g = b._dirtyLeaves;
    h = g.size;
    k = b._dirtyElements;
    m = k.size;
    $b++;
  }

  b._dirtyLeaves = c;
  b._dirtyElements = d;
}

function nf(a, b) {
  var c = a.type,
      d = b.get(c);
  void 0 === d && r(17, c);
  c = d.klass;
  a.type !== c.getType() && r(18, c.name);
  c = c.importJSON(a);
  a = a.children;
  if (D(c) && Array.isArray(a)) for (d = 0; d < a.length; d++) {
    var e = nf(a[d], b);
    c.append(e);
  }
  return c;
}

function of(a, b) {
  var c = S,
      d = V,
      e = T;
  S = a;
  V = !0;
  T = null;

  try {
    return b();
  } finally {
    S = c, V = d, T = e;
  }
}

function pf(a, b) {
  var c = a._pendingEditorState,
      d = a._rootElement,
      e = a._headless || null === d;

  if (null !== c) {
    var f = a._editorState,
        g = f._selection,
        h = c._selection,
        k = 0 !== a._dirtyType,
        m = S,
        n = V,
        p = T,
        l = a._updating,
        q = a._observer,
        u = null;
    a._pendingEditorState = null;
    a._editorState = c;

    if (!e && k && null !== q) {
      T = a;
      S = c;
      V = !1;
      a._updating = !0;

      try {
        var E = a._dirtyType,
            Q = a._dirtyElements,
            R = a._dirtyLeaves;
        q.disconnect();
        var x = E,
            y = Q,
            A = R;
        M = Kc = L = "";
        Nc = 2 === x;
        Qc = null;
        N = a;
        Lc = a._config;
        Mc = a._nodes;
        Pc = N._listeners.mutation;
        Rc = y;
        Sc = A;
        Tc = f._nodeMap;
        Uc = c._nodeMap;
        Oc = c._readOnly;
        Vc = new Map(a._keyToDOMMap);
        var ia = new Map();
        ed = ia;
        sd("root", null);
        ed = Vc = Lc = Uc = Tc = Sc = Rc = Mc = N = void 0;
        u = ia;
      } catch (E) {
        E instanceof Error && a._onError(E);
        if (hf) throw E;
        qf(a, null, d, c);
        Bb(a);
        a._dirtyType = 2;
        hf = !0;
        pf(a, f);
        hf = !1;
        return;
      } finally {
        q.observe(d, jf), a._updating = l, S = m, V = n, T = p;
      }
    }

    c._readOnly || (c._readOnly = !0);
    var Z = a._dirtyLeaves,
        ca = a._dirtyElements,
        Va = a._normalizedNodes,
        la = a._updateTags,
        Wc = a._deferred;
    k && (a._dirtyType = 0, a._cloneNotNeeded.clear(), a._dirtyLeaves = new Set(), a._dirtyElements = new Map(), a._normalizedNodes = new Set(), a._updateTags = new Set());
    var Ee = a._decorators,
        Pb = a._pendingDecorators || Ee,
        Ef = c._nodeMap,
        Xc;

    for (Xc in Pb) {
      Ef.has(Xc) || (Pb === Ee && (Pb = fc(a)), delete Pb[Xc]);
    }

    var ja = e ? null : vb(a._window);

    if (a._editable && null !== ja && (k || null === h || h.dirty)) {
      T = a;
      S = c;

      try {
        null !== q && q.disconnect();

        if (k || null === h || h.dirty) {
          var _E = a._blockCursorElement;
          null !== _E && Dc(_E, a, d);

          a: {
            var _Q = ja.anchorNode,
                _R = ja.focusNode,
                _ia = ja.anchorOffset,
                lb = ja.focusOffset,
                W = document.activeElement;
            if (!(la.has("collaboration") && W !== d || null !== W && Kb(W))) if (C(h)) {
              var mb = h.anchor,
                  Yc = h.focus,
                  Fe = mb.key,
                  Ff = Yc.key,
                  Ge = vc(a, Fe),
                  He = vc(a, Ff),
                  Qb = mb.offset,
                  Ie = Yc.offset,
                  Zc = h.format,
                  $c = h.style,
                  Je = h.isCollapsed(),
                  nb = Ge,
                  Rb = He,
                  ad = !1;

              if ("text" === mb.type) {
                nb = Vb(Ge);
                var X = mb.getNode();
                ad = X.getFormat() !== Zc || X.getStyle() !== $c;
              } else C(g) && "text" === g.anchor.type && (ad = !0);

              "text" === Yc.type && (Rb = Vb(He));

              if (null !== nb && null !== Rb) {
                if (Je && (null === g || ad || C(g) && (g.format !== Zc || g.style !== $c))) {
                  var Gf = performance.now();
                  Md = [Zc, $c, Qb, Fe, Gf];
                }

                if (_ia === Qb && lb === Ie && _Q === nb && _R === Rb && ("Range" !== ja.type || !Je) && (null !== W && d.contains(W) || d.focus({
                  preventScroll: !0
                }), "element" !== mb.type)) break a;

                try {
                  ja.setBaseAndExtent(nb, Qb, Rb, Ie);
                } catch (X) {}

                if (!la.has("skip-scroll-into-view") && h.isCollapsed() && null !== d && d === document.activeElement) {
                  var _X = h instanceof Ne && "element" === h.anchor.type ? nb.childNodes[Qb] || null : 0 < ja.rangeCount ? ja.getRangeAt(0) : null;

                  if (null !== _X) {
                    var Y;

                    if (_X instanceof Text) {
                      var U = document.createRange();
                      U.selectNode(_X);
                      Y = U.getBoundingClientRect();
                    } else Y = _X.getBoundingClientRect();

                    var wa = d.ownerDocument,
                        Da = wa.defaultView;
                    if (null !== Da) for (var _Y = Y, bd = _Y.top, cd = _Y.bottom, Sb, Tb, oa = d; null !== oa;) {
                      var _U = oa === wa.body;

                      if (_U) Sb = 0, Tb = Cb(a).innerHeight;else {
                        var Ub = oa.getBoundingClientRect();
                        Sb = Ub.top;
                        Tb = Ub.bottom;
                      }
                      var Ea = 0;
                      bd < Sb ? Ea = -(Sb - bd) : cd > Tb && (Ea = cd - Tb);
                      if (0 !== Ea) if (_U) Da.scrollBy(0, Ea);else {
                        var _Ub = oa.scrollTop;
                        oa.scrollTop += Ea;
                        var Ke = oa.scrollTop - _Ub;
                        bd -= Ke;
                        cd -= Ke;
                      }
                      if (_U) break;
                      oa = Nb(oa);
                    }
                  }
                }

                Id = !0;
              }
            } else null !== g && Lb(a, _Q, _R) && ja.removeAllRanges();
          }
        }

        a: {
          var _E2 = a._blockCursorElement;

          if (C(h) && h.isCollapsed() && "element" === h.anchor.type && d.contains(document.activeElement)) {
            var _Q2 = h.anchor,
                _R2 = _Q2.getNode(),
                _ia2 = _Q2.offset,
                _lb = _R2.getChildrenSize(),
                _W = !1,
                _X2 = null;

            if (_ia2 === _lb) {
              var _Y2 = _R2.getChildAtIndex(_ia2 - 1);

              Cc(_Y2) && (_W = !0);
            } else {
              var _Y3 = _R2.getChildAtIndex(_ia2);

              if (Cc(_Y3)) {
                var _wa = _Y3.getPreviousSibling();

                if (null === _wa || Cc(_wa)) _W = !0, _X2 = a.getElementByKey(_Y3.__key);
              }
            }

            if (_W) {
              var _Y4 = a.getElementByKey(_R2.__key);

              if (null === _E2) {
                var _wa2 = a._config.theme,
                    _Da = document.createElement("div");

                _Da.contentEditable = "false";

                _Da.setAttribute("data-lexical-cursor", "true");

                var _U2 = _wa2.blockCursor;

                if (void 0 !== _U2) {
                  var _Da$classList;

                  if ("string" === typeof _U2) {
                    var _Ea = _U2.split(" ");

                    _U2 = _wa2.blockCursor = _Ea;
                  }

                  void 0 !== _U2 && (_Da$classList = _Da.classList).add.apply(_Da$classList, _toConsumableArray(_U2));
                }

                a._blockCursorElement = _E2 = _Da;
              }

              d.style.caretColor = "transparent";
              null === _X2 ? _Y4.appendChild(_E2) : _Y4.insertBefore(_E2, _X2);
              break a;
            }
          }

          null !== _E2 && Dc(_E2, a, d);
        }

        null !== q && q.observe(d, jf);
      } finally {
        T = p, S = m;
      }
    }

    if (null !== u) {
      var Hf = u;

      var _E3 = Array.from(a._listeners.mutation),
          _Q3 = _E3.length;

      for (var _R3 = 0; _R3 < _Q3; _R3++) {
        var _E3$_R = _slicedToArray(_E3[_R3], 2),
            _ia3 = _E3$_R[0],
            _lb2 = _E3$_R[1],
            _W2 = Hf.get(_lb2);

        void 0 !== _W2 && _ia3(_W2, {
          dirtyLeaves: Z,
          prevEditorState: f,
          updateTags: la
        });
      }
    }

    C(h) || null === h || null !== g && g.is(h) || a.dispatchCommand(aa, void 0);
    var dd = a._pendingDecorators;
    null !== dd && (a._decorators = dd, a._pendingDecorators = null, rf("decorator", a, !0, dd));
    var If = gc(b || f),
        Le = gc(c);
    If !== Le && rf("textcontent", a, !0, Le);
    rf("update", a, !0, {
      dirtyElements: ca,
      dirtyLeaves: Z,
      editorState: c,
      normalizedNodes: Va,
      prevEditorState: b || f,
      tags: la
    });
    a._deferred = [];

    if (0 !== Wc.length) {
      var _E4 = a._updating;
      a._updating = !0;

      try {
        for (var _Q4 = 0; _Q4 < Wc.length; _Q4++) {
          Wc[_Q4]();
        }
      } finally {
        a._updating = _E4;
      }
    }

    var Me = a._updates;

    if (0 !== Me.length) {
      var _E5 = Me.shift();

      if (_E5) {
        var _E6 = _slicedToArray(_E5, 2),
            _Q5 = _E6[0],
            _R4 = _E6[1];

        sf(a, _Q5, _R4);
      }
    }
  }
}

function rf(a, b, c) {
  var e = b._updating;
  b._updating = c;

  try {
    var f = Array.from(b._listeners[a]);

    for (var _len2 = arguments.length, d = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      d[_key2 - 3] = arguments[_key2];
    }

    for (a = 0; a < f.length; a++) {
      f[a].apply(null, d);
    }
  } finally {
    b._updating = e;
  }
}

function O(a, b, c) {
  if (!1 === a._updating || T !== a) {
    var f = !1;
    a.update(function () {
      f = O(a, b, c);
    });
    return f;
  }

  var d = lc(a);

  for (var _f4 = 4; 0 <= _f4; _f4--) {
    for (var g = 0; g < d.length; g++) {
      var e = d[g]._commands.get(b);

      if (void 0 !== e && (e = e[_f4], void 0 !== e)) {
        e = Array.from(e);
        var h = e.length;

        for (var k = 0; k < h; k++) {
          if (!0 === e[k](c, a)) return !0;
        }
      }
    }
  }

  return !1;
}

function tf(a, b) {
  var c = a._updates;

  for (b = b || !1; 0 !== c.length;) {
    var d = c.shift();

    if (d) {
      var _d5 = d,
          _d6 = _slicedToArray(_d5, 2),
          e = _d6[0],
          f = _d6[1],
          g = void 0;

      void 0 !== f && (d = f.onUpdate, g = f.tag, f.skipTransforms && (b = !0), d && a._deferred.push(d), g && a._updateTags.add(g));
      e();
    }
  }

  return b;
}

function sf(a, b, c) {
  var d = a._updateTags;
  var e,
      f = e = !1;

  if (void 0 !== c) {
    var g = c.onUpdate;
    e = c.tag;
    null != e && d.add(e);
    e = c.skipTransforms || !1;
    f = c.discrete || !1;
  }

  g && a._deferred.push(g);
  c = a._editorState;
  g = a._pendingEditorState;
  var h = !1;
  if (null === g || g._readOnly) g = a._pendingEditorState = new uf(new Map((g || c)._nodeMap)), h = !0;
  g._flushSync = f;
  f = S;
  var k = V,
      m = T,
      n = a._updating;
  S = g;
  V = !1;
  a._updating = !0;
  T = a;

  try {
    h && (a._headless ? null != c._selection && (g._selection = c._selection.clone()) : g._selection = df(a));
    var p = a._compositionKey;
    b();
    e = tf(a, e);
    ff(g, a);
    0 !== a._dirtyType && (e ? lf(g, a) : mf(g, a), tf(a), Jc(c, g, a._dirtyLeaves, a._dirtyElements));
    p !== a._compositionKey && (g._flushSync = !0);
    var l = g._selection;

    if (C(l)) {
      var q = g._nodeMap,
          u = l.focus.key;
      void 0 !== q.get(l.anchor.key) && void 0 !== q.get(u) || r(19);
    } else Ud(l) && 0 === l._nodes.size && (g._selection = null);
  } catch (p) {
    p instanceof Error && a._onError(p);
    a._pendingEditorState = c;
    a._dirtyType = 2;

    a._cloneNotNeeded.clear();

    a._dirtyLeaves = new Set();

    a._dirtyElements.clear();

    pf(a);
    return;
  } finally {
    S = f, V = k, T = m, a._updating = n, $b = 0;
  }

  0 !== a._dirtyType || vf(g, a) ? g._flushSync ? (g._flushSync = !1, pf(a)) : h && Jb(function () {
    pf(a);
  }) : (g._flushSync = !1, h && (d.clear(), a._deferred = [], a._pendingEditorState = null));
}

function w(a, b, c) {
  a._updating ? a._updates.push([b, c]) : sf(a, b, c);
}

var wf = /*#__PURE__*/function (_be3) {
  _inherits(wf, _be3);

  var _super4 = _createSuper(wf);

  function wf(a) {
    _classCallCheck(this, wf);

    return _super4.call(this, a);
  }

  _createClass(wf, [{
    key: "decorate",
    value: function decorate() {
      r(47);
    }
  }, {
    key: "isIsolated",
    value: function isIsolated() {
      return !1;
    }
  }, {
    key: "isInline",
    value: function isInline() {
      return !0;
    }
  }, {
    key: "isKeyboardSelectable",
    value: function isKeyboardSelectable() {
      return !0;
    }
  }]);

  return wf;
}(be);

function z(a) {
  return a instanceof wf;
}

var xf = /*#__PURE__*/function (_be4) {
  _inherits(xf, _be4);

  var _super5 = _createSuper(xf);

  function xf(a) {
    var _this4;

    _classCallCheck(this, xf);

    _this4 = _super5.call(this, a);
    _this4.__last = _this4.__first = null;
    _this4.__indent = _this4.__format = _this4.__size = 0;
    _this4.__dir = null;
    return _this4;
  }

  _createClass(xf, [{
    key: "getFormat",
    value: function getFormat() {
      return this.getLatest().__format;
    }
  }, {
    key: "getFormatType",
    value: function getFormatType() {
      var a = this.getFormat();
      return ib[a] || "";
    }
  }, {
    key: "getIndent",
    value: function getIndent() {
      return this.getLatest().__indent;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var a = [],
          b = this.getFirstChild();

      for (; null !== b;) {
        a.push(b), b = b.getNextSibling();
      }

      return a;
    }
  }, {
    key: "getChildrenKeys",
    value: function getChildrenKeys() {
      var a = [],
          b = this.getFirstChild();

      for (; null !== b;) {
        a.push(b.__key), b = b.getNextSibling();
      }

      return a;
    }
  }, {
    key: "getChildrenSize",
    value: function getChildrenSize() {
      return this.getLatest().__size;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return 0 === this.getChildrenSize();
    }
  }, {
    key: "isDirty",
    value: function isDirty() {
      var a = F()._dirtyElements;

      return null !== a && a.has(this.__key);
    }
  }, {
    key: "isLastChild",
    value: function isLastChild() {
      var a = this.getLatest(),
          b = this.getParentOrThrow().getLastChild();
      return null !== b && b.is(a);
    }
  }, {
    key: "getAllTextNodes",
    value: function getAllTextNodes() {
      var a = [],
          b = this.getFirstChild();

      for (; null !== b;) {
        B(b) && a.push(b);

        if (D(b)) {
          var c = b.getAllTextNodes();
          a.push.apply(a, _toConsumableArray(c));
        }

        b = b.getNextSibling();
      }

      return a;
    }
  }, {
    key: "getFirstDescendant",
    value: function getFirstDescendant() {
      var a = this.getFirstChild();

      for (; null !== a;) {
        if (D(a)) {
          var b = a.getFirstChild();

          if (null !== b) {
            a = b;
            continue;
          }
        }

        break;
      }

      return a;
    }
  }, {
    key: "getLastDescendant",
    value: function getLastDescendant() {
      var a = this.getLastChild();

      for (; null !== a;) {
        if (D(a)) {
          var b = a.getLastChild();

          if (null !== b) {
            a = b;
            continue;
          }
        }

        break;
      }

      return a;
    }
  }, {
    key: "getDescendantByIndex",
    value: function getDescendantByIndex(a) {
      var b = this.getChildren(),
          c = b.length;
      if (a >= c) return a = b[c - 1], D(a) && a.getLastDescendant() || a || null;
      a = b[a];
      return D(a) && a.getFirstDescendant() || a || null;
    }
  }, {
    key: "getFirstChild",
    value: function getFirstChild() {
      var a = this.getLatest().__first;

      return null === a ? null : I(a);
    }
  }, {
    key: "getFirstChildOrThrow",
    value: function getFirstChildOrThrow() {
      var a = this.getFirstChild();
      null === a && r(45, this.__key);
      return a;
    }
  }, {
    key: "getLastChild",
    value: function getLastChild() {
      var a = this.getLatest().__last;

      return null === a ? null : I(a);
    }
  }, {
    key: "getLastChildOrThrow",
    value: function getLastChildOrThrow() {
      var a = this.getLastChild();
      null === a && r(96, this.__key);
      return a;
    }
  }, {
    key: "getChildAtIndex",
    value: function getChildAtIndex(a) {
      var b = this.getChildrenSize();
      var c;

      if (a < b / 2) {
        c = this.getFirstChild();

        for (b = 0; null !== c && b <= a;) {
          if (b === a) return c;
          c = c.getNextSibling();
          b++;
        }

        return null;
      }

      c = this.getLastChild();

      for (--b; null !== c && b >= a;) {
        if (b === a) return c;
        c = c.getPreviousSibling();
        b--;
      }

      return null;
    }
  }, {
    key: "getTextContent",
    value: function getTextContent() {
      var a = "",
          b = this.getChildren(),
          c = b.length;

      for (var d = 0; d < c; d++) {
        var e = b[d];
        a += e.getTextContent();
        D(e) && d !== c - 1 && !e.isInline() && (a += "\n\n");
      }

      return a;
    }
  }, {
    key: "getTextContentSize",
    value: function getTextContentSize() {
      var a = 0,
          b = this.getChildren(),
          c = b.length;

      for (var d = 0; d < c; d++) {
        var e = b[d];
        a += e.getTextContentSize();
        D(e) && d !== c - 1 && !e.isInline() && (a += 2);
      }

      return a;
    }
  }, {
    key: "getDirection",
    value: function getDirection() {
      return this.getLatest().__dir;
    }
  }, {
    key: "hasFormat",
    value: function hasFormat(a) {
      return "" !== a ? (a = hb[a], 0 !== (this.getFormat() & a)) : !1;
    }
  }, {
    key: "select",
    value: function select(a, b) {
      G();
      var c = v(),
          d = a,
          e = b;
      var f = this.getChildrenSize();
      if (!this.canBeEmpty()) if (0 === a && 0 === b) {
        if (a = this.getFirstChild(), B(a) || D(a)) return a.select(0, 0);
      } else if (!(void 0 !== a && a !== f || void 0 !== b && b !== f) && (a = this.getLastChild(), B(a) || D(a))) return a.select();
      void 0 === d && (d = f);
      void 0 === e && (e = f);
      f = this.__key;
      if (C(c)) c.anchor.set(f, d, "element"), c.focus.set(f, e, "element"), c.dirty = !0;else return re(f, d, f, e, "element", "element");
      return c;
    }
  }, {
    key: "selectStart",
    value: function selectStart() {
      var a = this.getFirstDescendant();
      return D(a) || B(a) ? a.select(0, 0) : null !== a ? a.selectPrevious() : this.select(0, 0);
    }
  }, {
    key: "selectEnd",
    value: function selectEnd() {
      var a = this.getLastDescendant();
      return D(a) || B(a) ? a.select() : null !== a ? a.selectNext() : this.select();
    }
  }, {
    key: "clear",
    value: function clear() {
      var a = this.getWritable();
      this.getChildren().forEach(function (b) {
        return b.remove();
      });
      return a;
    }
  }, {
    key: "append",
    value: function append() {
      for (var _len3 = arguments.length, a = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        a[_key3] = arguments[_key3];
      }

      return this.splice(this.getChildrenSize(), 0, a);
    }
  }, {
    key: "setDirection",
    value: function setDirection(a) {
      var b = this.getWritable();
      b.__dir = a;
      return b;
    }
  }, {
    key: "setFormat",
    value: function setFormat(a) {
      this.getWritable().__format = "" !== a ? hb[a] : 0;
      return this;
    }
  }, {
    key: "setIndent",
    value: function setIndent(a) {
      this.getWritable().__indent = a;
      return this;
    }
  }, {
    key: "splice",
    value: function splice(a, b, c) {
      var d = c.length,
          e = this.getChildrenSize(),
          f = this.getWritable(),
          g = f.__key;
      var h = [],
          k = [];
      var m = this.getChildAtIndex(a + b),
          n = null,
          p = e - b + d;
      if (0 !== a) if (a === e) n = this.getLastChild();else {
        var l = this.getChildAtIndex(a);
        null !== l && (n = l.getPreviousSibling());
      }

      if (0 < b) {
        var q = null === n ? this.getFirstChild() : n.getNextSibling();

        for (l = 0; l < b; l++) {
          null === q && r(100);
          var u = q.getNextSibling(),
              x = q.__key;
          q = q.getWritable();
          bc(q);
          k.push(x);
          q = u;
        }
      }

      l = n;

      for (u = 0; u < d; u++) {
        x = c[u];
        null !== l && x.is(l) && (n = l = l.getPreviousSibling());
        q = x.getWritable();
        q.__parent === g && p--;
        bc(q);
        var y = x.__key;
        null === l ? (f.__first = y, q.__prev = null) : (l = l.getWritable(), l.__next = y, q.__prev = l.__key);
        x.__key === g && r(76);
        q.__parent = g;
        h.push(y);
        l = x;
      }

      a + b === e ? null !== l && (l.getWritable().__next = null, f.__last = l.__key) : null !== m && (a = m.getWritable(), null !== l ? (b = l.getWritable(), a.__prev = l.__key, b.__next = m.__key) : a.__prev = null);
      f.__size = p;

      if (k.length && (a = v(), C(a))) {
        k = new Set(k);
        h = new Set(h);
        var _a11 = a,
            _y = _a11.anchor,
            A = _a11.focus;
        yf(_y, k, h) && $d(_y, _y.getNode(), this, n, m);
        yf(A, k, h) && $d(A, A.getNode(), this, n, m);
        0 !== p || this.canBeEmpty() || yc(this) || this.remove();
      }

      return f;
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return {
        children: [],
        direction: this.getDirection(),
        format: this.getFormatType(),
        indent: this.getIndent(),
        type: "element",
        version: 1
      };
    }
  }, {
    key: "insertNewAfter",
    value: function insertNewAfter() {
      return null;
    }
  }, {
    key: "canIndent",
    value: function canIndent() {
      return !0;
    }
  }, {
    key: "collapseAtStart",
    value: function collapseAtStart() {
      return !1;
    }
  }, {
    key: "excludeFromCopy",
    value: function excludeFromCopy() {
      return !1;
    }
  }, {
    key: "canExtractContents",
    value: function canExtractContents() {
      return !0;
    }
  }, {
    key: "canReplaceWith",
    value: function canReplaceWith() {
      return !0;
    }
  }, {
    key: "canInsertAfter",
    value: function canInsertAfter() {
      return !0;
    }
  }, {
    key: "canBeEmpty",
    value: function canBeEmpty() {
      return !0;
    }
  }, {
    key: "canInsertTextBefore",
    value: function canInsertTextBefore() {
      return !0;
    }
  }, {
    key: "canInsertTextAfter",
    value: function canInsertTextAfter() {
      return !0;
    }
  }, {
    key: "isInline",
    value: function isInline() {
      return !1;
    }
  }, {
    key: "isShadowRoot",
    value: function isShadowRoot() {
      return !1;
    }
  }, {
    key: "canMergeWith",
    value: function canMergeWith() {
      return !1;
    }
  }, {
    key: "extractWithChild",
    value: function extractWithChild() {
      return !1;
    }
  }]);

  return xf;
}(be);

function D(a) {
  return a instanceof xf;
}

function yf(a, b, c) {
  for (a = a.getNode(); a;) {
    var d = a.__key;
    if (b.has(d) && !c.has(d)) return !0;
    a = a.getParent();
  }

  return !1;
}

var zf = /*#__PURE__*/function (_xf) {
  _inherits(zf, _xf);

  var _super6 = _createSuper(zf);

  function zf() {
    var _this5;

    _classCallCheck(this, zf);

    _this5 = _super6.call(this, "root");
    _this5.__cachedText = null;
    return _this5;
  }

  _createClass(zf, [{
    key: "getTopLevelElementOrThrow",
    value: function getTopLevelElementOrThrow() {
      r(51);
    }
  }, {
    key: "getTextContent",
    value: function getTextContent() {
      var a = this.__cachedText;
      return !ec() && 0 !== F()._dirtyType || null === a ? _get(_getPrototypeOf(zf.prototype), "getTextContent", this).call(this) : a;
    }
  }, {
    key: "remove",
    value: function remove() {
      r(52);
    }
  }, {
    key: "replace",
    value: function replace() {
      r(53);
    }
  }, {
    key: "insertBefore",
    value: function insertBefore() {
      r(54);
    }
  }, {
    key: "insertAfter",
    value: function insertAfter() {
      r(55);
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return !1;
    }
  }, {
    key: "append",
    value: function append() {
      var _get2;

      for (var _len4 = arguments.length, a = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        a[_key4] = arguments[_key4];
      }

      for (var b = 0; b < a.length; b++) {
        var c = a[b];
        D(c) || z(c) || r(56);
      }

      return (_get2 = _get(_getPrototypeOf(zf.prototype), "append", this)).call.apply(_get2, [this].concat(a));
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return {
        children: [],
        direction: this.getDirection(),
        format: this.getFormatType(),
        indent: this.getIndent(),
        type: "root",
        version: 1
      };
    }
  }, {
    key: "collapseAtStart",
    value: function collapseAtStart() {
      return !0;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "root";
    }
  }, {
    key: "clone",
    value: function clone() {
      return new zf();
    }
  }, {
    key: "importJSON",
    value: function importJSON(a) {
      var b = hc();
      b.setFormat(a.format);
      b.setIndent(a.indent);
      b.setDirection(a.direction);
      return b;
    }
  }]);

  return zf;
}(xf);

function K(a) {
  return a instanceof zf;
}

function vf(a, b) {
  b = b.getEditorState()._selection;
  a = a._selection;

  if (null !== a) {
    if (a.dirty || !a.is(b)) return !0;
  } else if (null !== b) return !0;

  return !1;
}

function Af() {
  return new uf(new Map([["root", new zf()]]));
}

function Bf(a) {
  var b = a.exportJSON();
  var c = a.constructor;
  b.type !== c.getType() && r(130, c.name);
  var d = b.children;
  if (D(a)) for (Array.isArray(d) || r(59, c.name), a = a.getChildren(), c = 0; c < a.length; c++) {
    var e = Bf(a[c]);
    d.push(e);
  }
  return b;
}

var uf = /*#__PURE__*/function () {
  function uf(a, b) {
    _classCallCheck(this, uf);

    this._nodeMap = a;
    this._selection = b || null;
    this._readOnly = this._flushSync = !1;
  }

  _createClass(uf, [{
    key: "isEmpty",
    value: function isEmpty() {
      return 1 === this._nodeMap.size && null === this._selection;
    }
  }, {
    key: "read",
    value: function read(a) {
      return of(this, a);
    }
  }, {
    key: "clone",
    value: function clone(a) {
      a = new uf(this._nodeMap, void 0 === a ? this._selection : a);
      a._readOnly = !0;
      return a;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return of(this, function () {
        return {
          root: Bf(hc())
        };
      });
    }
  }]);

  return uf;
}();

var Cf = /*#__PURE__*/function (_xf2) {
  _inherits(Cf, _xf2);

  var _super7 = _createSuper(Cf);

  function Cf() {
    _classCallCheck(this, Cf);

    return _super7.apply(this, arguments);
  }

  _createClass(Cf, [{
    key: "createDOM",
    value: function createDOM(a) {
      var _b$classList;

      var b = document.createElement("p");
      a = qc(a.theme, "paragraph");
      void 0 !== a && (_b$classList = b.classList).add.apply(_b$classList, _toConsumableArray(a));
      return b;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return !1;
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(a) {
      var _get$call2 = _get(_getPrototypeOf(Cf.prototype), "exportDOM", this).call(this, a);

      a = _get$call2.element;

      if (a && Hc(a)) {
        this.isEmpty() && a.append(document.createElement("br"));
        var b = this.getFormatType();
        a.style.textAlign = b;
        if (b = this.getDirection()) a.dir = b;
        b = this.getIndent();
        0 < b && (a.style.textIndent = "".concat(20 * b, "px"));
      }

      return {
        element: a
      };
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(Cf.prototype), "exportJSON", this).call(this)), {}, {
        type: "paragraph",
        version: 1
      });
    }
  }, {
    key: "insertNewAfter",
    value: function insertNewAfter(a, b) {
      a = de();
      var c = this.getDirection();
      a.setDirection(c);
      this.insertAfter(a, b);
      return a;
    }
  }, {
    key: "collapseAtStart",
    value: function collapseAtStart() {
      var a = this.getChildren();

      if (0 === a.length || B(a[0]) && "" === a[0].getTextContent().trim()) {
        if (null !== this.getNextSibling()) return this.selectNext(), this.remove(), !0;
        if (null !== this.getPreviousSibling()) return this.selectPrevious(), this.remove(), !0;
      }

      return !1;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "paragraph";
    }
  }, {
    key: "clone",
    value: function clone(a) {
      return new Cf(a.__key);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        p: function p() {
          return {
            conversion: Df,
            priority: 0
          };
        }
      };
    }
  }, {
    key: "importJSON",
    value: function importJSON(a) {
      var b = de();
      b.setFormat(a.format);
      b.setIndent(a.indent);
      b.setDirection(a.direction);
      return b;
    }
  }]);

  return Cf;
}(xf);

function Df(a) {
  var b = de();
  a.style && (b.setFormat(a.style.textAlign), a = parseInt(a.style.textIndent, 10) / 20, 0 < a && b.setIndent(a));
  return {
    node: b
  };
}

function de() {
  return Ac(new Cf());
}

function qf(a, b, c, d) {
  var e = a._keyToDOMMap;
  e.clear();
  a._editorState = Af();
  a._pendingEditorState = d;
  a._compositionKey = null;
  a._dirtyType = 0;

  a._cloneNotNeeded.clear();

  a._dirtyLeaves = new Set();

  a._dirtyElements.clear();

  a._normalizedNodes = new Set();
  a._updateTags = new Set();
  a._updates = [];
  a._blockCursorElement = null;
  d = a._observer;
  null !== d && (d.disconnect(), a._observer = null);
  null !== b && (b.textContent = "");
  null !== c && (c.textContent = "", e.set("root", c));
}

function Jf(a) {
  var b = new Map(),
      c = new Set();
  a.forEach(function (d) {
    d = null != d.klass.importDOM ? d.klass.importDOM.bind(d.klass) : null;

    if (null != d && !c.has(d)) {
      c.add(d);
      var e = d();
      null !== e && Object.keys(e).forEach(function (f) {
        var g = b.get(f);
        void 0 === g && (g = [], b.set(f, g));
        g.push(e[f]);
      });
    }
  });
  return b;
}

var Kf = /*#__PURE__*/function () {
  function Kf(a, b, c, d, e, f, g) {
    _classCallCheck(this, Kf);

    this._parentEditor = b;
    this._rootElement = null;
    this._editorState = a;
    this._compositionKey = this._pendingEditorState = null;
    this._deferred = [];
    this._keyToDOMMap = new Map();
    this._updates = [];
    this._updating = !1;
    this._listeners = {
      decorator: new Set(),
      editable: new Set(),
      mutation: new Map(),
      root: new Set(),
      textcontent: new Set(),
      update: new Set()
    };
    this._commands = new Map();
    this._config = d;
    this._nodes = c;
    this._decorators = {};
    this._pendingDecorators = null;
    this._dirtyType = 0;
    this._cloneNotNeeded = new Set();
    this._dirtyLeaves = new Set();
    this._dirtyElements = new Map();
    this._normalizedNodes = new Set();
    this._updateTags = new Set();
    this._observer = null;
    this._key = mc();
    this._onError = e;
    this._htmlConversions = f;
    this._editable = g;
    this._headless = null !== b && b._headless;
    this._blockCursorElement = this._window = null;
  }

  _createClass(Kf, [{
    key: "isComposing",
    value: function isComposing() {
      return null != this._compositionKey;
    }
  }, {
    key: "registerUpdateListener",
    value: function registerUpdateListener(a) {
      var b = this._listeners.update;
      b.add(a);
      return function () {
        b.delete(a);
      };
    }
  }, {
    key: "registerEditableListener",
    value: function registerEditableListener(a) {
      var b = this._listeners.editable;
      b.add(a);
      return function () {
        b.delete(a);
      };
    }
  }, {
    key: "registerDecoratorListener",
    value: function registerDecoratorListener(a) {
      var b = this._listeners.decorator;
      b.add(a);
      return function () {
        b.delete(a);
      };
    }
  }, {
    key: "registerTextContentListener",
    value: function registerTextContentListener(a) {
      var b = this._listeners.textcontent;
      b.add(a);
      return function () {
        b.delete(a);
      };
    }
  }, {
    key: "registerRootListener",
    value: function registerRootListener(a) {
      var _this6 = this;

      var b = this._listeners.root;
      a(this._rootElement, null);
      b.add(a);
      return function () {
        a(null, _this6._rootElement);
        b.delete(a);
      };
    }
  }, {
    key: "registerCommand",
    value: function registerCommand(a, b, c) {
      void 0 === c && r(35);
      var d = this._commands;
      d.has(a) || d.set(a, [new Set(), new Set(), new Set(), new Set(), new Set()]);
      var e = d.get(a);
      void 0 === e && r(36, String(a));
      var f = e[c];
      f.add(b);
      return function () {
        f.delete(b);
        e.every(function (g) {
          return 0 === g.size;
        }) && d.delete(a);
      };
    }
  }, {
    key: "registerMutationListener",
    value: function registerMutationListener(a, b) {
      void 0 === this._nodes.get(a.getType()) && r(37, a.name);
      var c = this._listeners.mutation;
      c.set(b, a);
      return function () {
        c.delete(b);
      };
    }
  }, {
    key: "registerNodeTransformToKlass",
    value: function registerNodeTransformToKlass(a, b) {
      var c = a.getType();
      c = this._nodes.get(c);
      void 0 === c && r(37, a.name);
      c.transforms.add(b);
      return c;
    }
  }, {
    key: "registerNodeTransform",
    value: function registerNodeTransform(a, b) {
      var c = this.registerNodeTransformToKlass(a, b);
      var d = [c];
      c = c.replaceWithKlass;
      null != c && (c = this.registerNodeTransformToKlass(c, b), d.push(c));
      ic(this, a.getType());
      return function () {
        d.forEach(function (e) {
          return e.transforms.delete(b);
        });
      };
    }
  }, {
    key: "hasNode",
    value: function hasNode(a) {
      return this._nodes.has(a.getType());
    }
  }, {
    key: "hasNodes",
    value: function hasNodes(a) {
      return a.every(this.hasNode.bind(this));
    }
  }, {
    key: "dispatchCommand",
    value: function dispatchCommand(a, b) {
      return O(this, a, b);
    }
  }, {
    key: "getDecorators",
    value: function getDecorators() {
      return this._decorators;
    }
  }, {
    key: "getRootElement",
    value: function getRootElement() {
      return this._rootElement;
    }
  }, {
    key: "getKey",
    value: function getKey() {
      return this._key;
    }
  }, {
    key: "setRootElement",
    value: function setRootElement(a) {
      var b = this._rootElement;

      if (a !== b) {
        var _a$classList;

        var f = qc(this._config.theme, "root");
        var c = this._pendingEditorState || this._editorState;
        this._rootElement = a;
        qf(this, b, a, c);

        if (null !== b) {
          var _b$classList2;

          if (!this._config.disableEvents) {
            0 !== Hd && (Hd--, 0 === Hd && b.ownerDocument.removeEventListener("selectionchange", Xd));
            var d = b.__lexicalEditor;

            if (null !== d && void 0 !== d) {
              if (null !== d._parentEditor) {
                var e = lc(d);
                e = e[e.length - 1]._key;
                Wd.get(e) === d && Wd.delete(e);
              } else Wd.delete(d._key);

              b.__lexicalEditor = null;
            }

            d = Vd(b);

            for (e = 0; e < d.length; e++) {
              d[e]();
            }

            b.__lexicalEventHandles = [];
          }

          null != f && (_b$classList2 = b.classList).remove.apply(_b$classList2, _toConsumableArray(f));
        }

        null !== a ? (c = (c = a.ownerDocument) && c.defaultView || null, d = a.style, d.userSelect = "text", d.whiteSpace = "pre-wrap", d.wordBreak = "break-word", a.setAttribute("data-lexical-editor", "true"), this._window = c, this._dirtyType = 2, Bb(this), this._updateTags.add("history-merge"), pf(this), this._config.disableEvents || Yd(a, this), null != f && (_a$classList = a.classList).add.apply(_a$classList, _toConsumableArray(f))) : (this._editorState = c, this._window = this._pendingEditorState = null);
        rf("root", this, !1, a, b);
      }
    }
  }, {
    key: "getElementByKey",
    value: function getElementByKey(a) {
      return this._keyToDOMMap.get(a) || null;
    }
  }, {
    key: "getEditorState",
    value: function getEditorState() {
      return this._editorState;
    }
  }, {
    key: "setEditorState",
    value: function setEditorState(a, b) {
      a.isEmpty() && r(38);
      Ab(this);
      var c = this._pendingEditorState,
          d = this._updateTags;
      b = void 0 !== b ? b.tag : null;
      null === c || c.isEmpty() || (null != b && d.add(b), pf(this));
      this._pendingEditorState = a;
      this._dirtyType = 2;

      this._dirtyElements.set("root", !1);

      this._compositionKey = null;
      null != b && d.add(b);
      pf(this);
    }
  }, {
    key: "parseEditorState",
    value: function parseEditorState(a, b) {
      a = "string" === typeof a ? JSON.parse(a) : a;
      var c = Af(),
          d = S,
          e = V,
          f = T,
          g = this._dirtyElements,
          h = this._dirtyLeaves,
          k = this._cloneNotNeeded,
          m = this._dirtyType;
      this._dirtyElements = new Map();
      this._dirtyLeaves = new Set();
      this._cloneNotNeeded = new Set();
      this._dirtyType = 0;
      S = c;
      V = !1;
      T = this;

      try {
        nf(a.root, this._nodes), b && b(), c._readOnly = !0;
      } catch (n) {
        n instanceof Error && this._onError(n);
      } finally {
        this._dirtyElements = g, this._dirtyLeaves = h, this._cloneNotNeeded = k, this._dirtyType = m, S = d, V = e, T = f;
      }

      return c;
    }
  }, {
    key: "update",
    value: function update(a, b) {
      w(this, a, b);
    }
  }, {
    key: "focus",
    value: function focus(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var c = this._rootElement;
      null !== c && (c.setAttribute("autocapitalize", "off"), w(this, function () {
        var d = v(),
            e = hc();
        null !== d ? d.dirty = !0 : 0 !== e.getChildrenSize() && ("rootStart" === b.defaultSelection ? e.selectStart() : e.selectEnd());
      }, {
        onUpdate: function onUpdate() {
          c.removeAttribute("autocapitalize");
          a && a();
        },
        tag: "focus"
      }), null === this._pendingEditorState && c.removeAttribute("autocapitalize"));
    }
  }, {
    key: "blur",
    value: function blur() {
      var a = this._rootElement;
      null !== a && a.blur();
      a = vb(this._window);
      null !== a && a.removeAllRanges();
    }
  }, {
    key: "isEditable",
    value: function isEditable() {
      return this._editable;
    }
  }, {
    key: "setEditable",
    value: function setEditable(a) {
      this._editable !== a && (this._editable = a, rf("editable", this, !0, a));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        editorState: this._editorState.toJSON()
      };
    }
  }]);

  return Kf;
}();

var gf = /*#__PURE__*/function (_xf3) {
  _inherits(gf, _xf3);

  var _super8 = _createSuper(gf);

  function gf(a, b) {
    var _this7;

    _classCallCheck(this, gf);

    _this7 = _super8.call(this, b);
    _this7.__colSpan = a;
    _this7.__rowSpan = 1;
    return _this7;
  }

  _createClass(gf, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(gf.prototype), "exportJSON", this).call(this)), {}, {
        colSpan: this.__colSpan,
        rowSpan: this.__rowSpan
      });
    }
  }, {
    key: "getColSpan",
    value: function getColSpan() {
      return this.__colSpan;
    }
  }, {
    key: "setColSpan",
    value: function setColSpan(a) {
      this.getWritable().__colSpan = a;
      return this;
    }
  }, {
    key: "getRowSpan",
    value: function getRowSpan() {
      return this.__rowSpan;
    }
  }, {
    key: "setRowSpan",
    value: function setRowSpan(a) {
      this.getWritable().__rowSpan = a;
      return this;
    }
  }]);

  return gf;
}(xf);

function P(a) {
  return a instanceof gf;
}

var Lf = /*#__PURE__*/function (_xf4) {
  _inherits(Lf, _xf4);

  var _super9 = _createSuper(Lf);

  function Lf() {
    _classCallCheck(this, Lf);

    return _super9.apply(this, arguments);
  }

  return _createClass(Lf);
}(xf);

function Ue(a) {
  return a instanceof Lf;
}

var Mf = /*#__PURE__*/function (_xf5) {
  _inherits(Mf, _xf5);

  var _super10 = _createSuper(Mf);

  function Mf() {
    _classCallCheck(this, Mf);

    return _super10.apply(this, arguments);
  }

  return _createClass(Mf);
}(xf);

function Te(a) {
  return a instanceof Mf;
}

exports.$addUpdateTag = function (a) {
  G();

  F()._updateTags.add(a);
};

exports.$applyNodeReplacement = Ac;
exports.$copyNode = zc;
exports.$createLineBreakNode = ge;
exports.$createNodeSelection = Ze;
exports.$createParagraphNode = de;

exports.$createRangeSelection = function () {
  var a = new ze("root", 0, "element"),
      b = new ze("root", 0, "element");
  return new Ne(a, b, 0, "");
};

exports.$createTabNode = ue;
exports.$createTextNode = J;
exports.$getAdjacentNode = tc;
exports.$getNearestNodeFromDOMNode = ub;
exports.$getNearestRootOrShadowRoot = xc;
exports.$getNodeByKey = I;
exports.$getPreviousSelection = oc;
exports.$getRoot = hc;
exports.$getSelection = v;

exports.$getTextContent = function () {
  var a = v();
  return null === a ? "" : a.getTextContent();
};

exports.$hasAncestor = wc;

exports.$hasUpdateTag = function (a) {
  return F()._updateTags.has(a);
};

exports.$insertNodes = function (a, b) {
  var c = v() || oc();
  null === c && (c = hc().selectEnd());
  return c.insertNodes(a, b);
};

exports.$isBlockElementNode = Ye;
exports.$isDecoratorNode = z;
exports.$isElementNode = D;

exports.$isInlineElementOrDecoratorNode = function (a) {
  return D(a) && a.isInline() || z(a) && a.isInline();
};

exports.$isLeafNode = Xb;
exports.$isLineBreakNode = Yb;
exports.$isNodeSelection = Ud;

exports.$isParagraphNode = function (a) {
  return a instanceof Cf;
};

exports.$isRangeSelection = C;
exports.$isRootNode = K;
exports.$isRootOrShadowRoot = yc;

exports.$isTabNode = function (a) {
  return a instanceof ye;
};

exports.$isTextNode = B;

exports.$nodesOfType = function (a) {
  var b = ac();
  var c = b._readOnly,
      d = a.getType();
  b = b._nodeMap;
  var e = [];

  var _iterator11 = _createForOfIteratorHelper(b),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var _ref12 = _step11.value;

      var _ref11 = _slicedToArray(_ref12, 2);

      var f = _ref11[1];
      f instanceof a && f.__type === d && (c || f.isAttached()) && e.push(f);
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  return e;
};

exports.$normalizeSelection__EXPERIMENTAL = Gb;

exports.$parseSerializedNode = function (a) {
  return nf(a, F()._nodes);
};

exports.$selectAll = function () {
  var a = hc();
  a = a.select(0, a.getChildrenSize());
  yb(Gb(a));
};

exports.$setCompositionKey = H;
exports.$setSelection = yb;
exports.$splitNode = Ec;
exports.BLUR_COMMAND = Ra;
exports.CAN_REDO_COMMAND = {};
exports.CAN_UNDO_COMMAND = {};
exports.CLEAR_EDITOR_COMMAND = {};
exports.CLEAR_HISTORY_COMMAND = {};
exports.CLICK_COMMAND = ba;
exports.COMMAND_PRIORITY_CRITICAL = 4;
exports.COMMAND_PRIORITY_EDITOR = 0;
exports.COMMAND_PRIORITY_HIGH = 3;
exports.COMMAND_PRIORITY_LOW = 1;
exports.COMMAND_PRIORITY_NORMAL = 2;
exports.CONTROLLED_TEXT_INSERTION_COMMAND = ha;
exports.COPY_COMMAND = Na;
exports.CUT_COMMAND = Oa;
exports.DELETE_CHARACTER_COMMAND = da;
exports.DELETE_LINE_COMMAND = pa;
exports.DELETE_WORD_COMMAND = na;
exports.DEPRECATED_$computeGridMap = Ve;

exports.DEPRECATED_$createGridSelection = function () {
  var a = new ze("root", 0, "element"),
      b = new ze("root", 0, "element");
  return new Qe("root", a, b);
};

exports.DEPRECATED_$getGridCellNodeRect = Oe;
exports.DEPRECATED_$getNodeTriplet = Pe;
exports.DEPRECATED_$isGridCellNode = P;
exports.DEPRECATED_$isGridNode = Ue;
exports.DEPRECATED_$isGridRowNode = Te;
exports.DEPRECATED_$isGridSelection = Re;
exports.DEPRECATED_GridCellNode = gf;
exports.DEPRECATED_GridNode = Lf;
exports.DEPRECATED_GridRowNode = Mf;
exports.DRAGEND_COMMAND = Ma;
exports.DRAGOVER_COMMAND = La;
exports.DRAGSTART_COMMAND = Ka;
exports.DROP_COMMAND = Ja;
exports.DecoratorNode = wf;
exports.ElementNode = xf;
exports.FOCUS_COMMAND = Qa;
exports.FORMAT_ELEMENT_COMMAND = {};
exports.FORMAT_TEXT_COMMAND = qa;
exports.INDENT_CONTENT_COMMAND = {};
exports.INSERT_LINE_BREAK_COMMAND = ea;
exports.INSERT_PARAGRAPH_COMMAND = fa;
exports.INSERT_TAB_COMMAND = {};
exports.KEY_ARROW_DOWN_COMMAND = Aa;
exports.KEY_ARROW_LEFT_COMMAND = xa;
exports.KEY_ARROW_RIGHT_COMMAND = ua;
exports.KEY_ARROW_UP_COMMAND = za;
exports.KEY_BACKSPACE_COMMAND = Fa;
exports.KEY_DELETE_COMMAND = Ha;
exports.KEY_DOWN_COMMAND = ta;
exports.KEY_ENTER_COMMAND = Ba;
exports.KEY_ESCAPE_COMMAND = Ga;
exports.KEY_MODIFIER_COMMAND = Sa;
exports.KEY_SPACE_COMMAND = Ca;
exports.KEY_TAB_COMMAND = Ia;
exports.LineBreakNode = ee;
exports.MOVE_TO_END = va;
exports.MOVE_TO_START = ya;
exports.OUTDENT_CONTENT_COMMAND = {};
exports.PASTE_COMMAND = ka;
exports.ParagraphNode = Cf;
exports.REDO_COMMAND = sa;
exports.REMOVE_TEXT_COMMAND = ma;
exports.RootNode = zf;
exports.SELECTION_CHANGE_COMMAND = aa;
exports.SELECT_ALL_COMMAND = Pa;
exports.TabNode = ye;
exports.TextNode = me;
exports.UNDO_COMMAND = ra;

exports.createCommand = function () {
  return {};
};

exports.createEditor = function (a) {
  var b = a || {},
      c = T,
      d = b.theme || {};
  var e = void 0 === a ? c : b.parentEditor || null,
      f = b.disableEvents || !1,
      g = Af(),
      h = b.namespace || (null !== e ? e._config.namespace : mc()),
      k = b.editorState,
      m = [zf, me, ee, ye, Cf].concat(_toConsumableArray(b.nodes || [])),
      n = b.onError;
  b = void 0 !== b.editable ? b.editable : !0;
  if (void 0 === a && null !== c) a = c._nodes;else for (a = new Map(), c = 0; c < m.length; c++) {
    var l = m[c],
        q = null;
    var p = null;
    "function" !== typeof l && (p = l, l = p.replace, q = p.with, p = p.withKlass ? p.withKlass : null);
    var u = l.getType(),
        x = l.transform(),
        y = new Set();
    null !== x && y.add(x);
    a.set(u, {
      klass: l,
      replace: q,
      replaceWithKlass: p,
      transforms: y
    });
  }
  d = new Kf(g, e, a, {
    disableEvents: f,
    namespace: h,
    theme: d
  }, n ? n : console.error, Jf(a), b);
  void 0 !== k && (d._pendingEditorState = k, d._dirtyType = 2);
  return d;
};

exports.getNearestEditorFromDOMNode = Mb;

exports.isHTMLAnchorElement = function (a) {
  return Hc(a) && "A" === a.tagName;
};

exports.isHTMLElement = Hc;
exports.isSelectionCapturedInDecoratorInput = Kb;
exports.isSelectionWithinEditor = Lb;